{
    "brand": "Fireknife",
    "welcome": "i18n デモへようこそ！",
    "errors": {
        "invalidCredentials": "認証情報が無効です",
        "unauthorizedToAdd": "追加する権限がありません",
        "unauthorizedToDelete": "削除する権限がありません",
        "unauthorizedToResetTwoFactor": "二要素認証をリセットする権限がありません",
        "unauthorizedToEdit": "編集する権限がありません",
        "unauthorizedToGet": "取得する権限がありません",
        "unauthorizedToToggle": "切り替える権限がありません",
        "unauthorizedToImport": "FareHarbor からのインポート権限がありません",
        "doesNotExist": "存在しません",
        "notFound": "見つかりません",
        "areRequired": "必須です",
        "areRequiredParams": "必須パラメータが不足しています",
        "alreadyExists": "既に存在します",
        "alreadyExistsAtTheSameVenue": "同じ会場ですでに存在します",
        "alreadyExistsForTheSameShow": "同じショーですでに存在します",
        "commissionGroupAlreadyAssigned": "ユーザーはこのショーの別のコミッショングループにすでに割り当てられています",
        "affiliateCodeGeneration": "一意のアフィリエイトコードを生成できませんでした",
        "checkinClosed": "このタイムスロットのチェックインは終了しています",
        "email": "無効なメール形式です",
        "notAllowedToAdd": "追加できません",
        "notAllowedToDelete": "削除できません",
        "notAllowedToEdit": "編集できません",
        "notAllowedToGet": "取得できません",
        "seatsDoNotBelong": "一部の席がこのショーに属していません！",
        "invalidPaymentType": "無効な支払い方法です",
        "invalidRole": "無効な役割です",
        "emailAlreadyExists": "この会場には既に同じメールが存在します！",
        "unauthorizedToDelegate": "これらの権限を委任する権限がありません",
        "cannotRemoveOwnUsersManage": "自分のユーザー管理権限を削除することはできません",
        "userIsNotConnectedToThisVenue": "このユーザーはこの会場に接続されていません",
        "notAllowedToSwitchVenues": "この会場に切り替える権限がありません",
        "noAuthHeader": "認証ヘッダーが提供されていません！",
        "sessionExpired": "セッションの有効期限が切れました。再度ログインしてください！",
        "invalidJWT": "無効なJWTトークンです",
        "invalidBearerFormat": "Authorization ヘッダーはBearer形式である必要があります",
        "unauthorized": "権限なし",
        "alreadyInTheDesiredState": "すでに希望の状態です",
        "unauthorizedToTriggerThisAction": "この操作を実行する権限がありません",
        "orderNotPending": "注文は保留中ではありません",
        "unauthorizedToCancelReservation": "この予約をキャンセルする権限がありません",
        "unauthorizedToRefundReservation": "この予約を返金する権限がありません",
        "rollbackTimeNotSet": "このショーのロールバック時間が設定されていません",
        "invalidDate": "無効な日付です — 未来の有効な日付を指定してください",
        "rollbackTimeMustBeLater": "新しいロールバック時刻は現在の時刻より後である必要があります",
        "noTicketsInCart": "少なくとも1枚のチケットが必要です",
        "tripadvisorDataNotFound": "指定されたURLのショーにTripadvisorデータが見つかりません",
        "tripadvisorUrlInvalid": "TripadvisorのURLが無効です",
        "tripadvisorDataFetchError": "ショーのTripadvisorデータ取得中にエラーが発生しました",
        "unauthorizedToModifyTickets": "チケットを変更する権限がありません",
        "cannotModifyTicketsPendingOrder": "保留中の注文のチケットは変更できません",
        "cannotModifyTickets": "チケットを変更できません",
        "duplicateTicketSeats": "予約の席は一意である必要があります。重複した席が見つかりました。",
        "missingTicketSeat": "必要な席が不足しています。",
        "invalidTicketSeat": "無効なチケット席が指定されました。席を確認してください！",
        "seatAlreadyUsedInAnotherBooking": "この席は別の予約で既に使用されています。席: {{seatIds}}",
        "duplicateSeatsInBatch": "リクエストに重複する座席割り当てがあります",
        "seatNotCompatibleWithTicketType": "座席 {{seatId}} はチケットタイプと互換性がありません",
        "bookingItemsMismatch": "予約アイテムが予約と一致しません。予約を再読み込みしてください！",
        "fareharborImportError": "FareHarborからのデータインポート中にエラーが発生しました！",
        "widgetSlugNotFound": "ウィジェットスラッグが見つかりません。管理画面で正しいスラッグを確認してください。",
        "widgetLoadingError": "ウィジェットの読み込み中にエラーが発生しました。",
        "bookingCancellationNotAllowedBefore": "予約のキャンセルは{{time}}時間前までです。",
        "cancelReservationError": "予約のキャンセル中にエラーが発生しました。",
        "guestCancellationDisabled": "このショーではゲストによる自己キャンセルは許可されていません。",
        "noOffersSelected": "返金対象のオファーが選択されていません。",
        "noChunksSelected": "返金対象のチャンクが選択されていません。",
        "unknownError": "不明なエラーが発生しました。",
        "refundReservationError": "予約の返金中にエラーが発生しました。",
        "invalidAmount": "無効な金額です！",
        "maxRefundExceeded": "最大返金額を超えました！",
        "invalidPaymentMethod": "無効な支払い方法です",
        "unsupportedPaymentMethod": "サポートされていない支払い方法: {{method}}",
        "notEnoughFundsForRefund": "返金に十分な資金がありません。チャンク: {{chunkName}}, 金額: {{amount}}",
        "invalidTransactionId": "無効な取引IDです",
        "transactionNotFound": "取引が見つかりません",
        "transactionAlreadyFinished": "取引はすでに完了しています",
        "onlyCashTransactions": "現金取引のみ手動で完了できます",
        "transactionMustBeRefunding": "取引は返金中の注文に属している必要があります",
        "noVenueAccess": "この会場へのアクセス権がありません",
        "timeslotInPast": "過去のタイムスロットは予約できません",
        "bookingWindowClosed": "このタイムスロットの予約は締め切られました",
        "timeslotCancelled": "このタイムスロットはキャンセルされ、予約できなくなりました",
        "createReservationError": "予約の作成中にエラーが発生しました！",
        "createReservationErrorDetails": "予約を作成できませんでした。後でもう一度お試しいただくか、サポートにお問い合わせください。エラーの詳細は次のとおりです。",
        "blockLimitExceeded": "チケットタイプのブロック制限を超えました",
        "priceMismatch": "価格の不一致",
        "timeslotHasActiveBookings": "このタイムスロットにはアクティブな予約があります",
        "timeslotHasOnlyCancelledBookings": "このタイムスロットにはキャンセルされた予約のみがあります",
        "notEnoughSeatsProvided": "チケットタイプに十分な座席が提供されていません",
        "invalidSeatSelections": "無効な座席選択が提供されました",
        "invalidPrice": "無効な価格が指定されました",
        "duplicateTimeslotPrice": "同じチケットタイプとオプションに対する価格が重複しています",
        "errorWhileTryingToPayReservation": "予約の支払い中にエラーが発生しました",
        "noFilePresentInRequest": "リクエストにファイルが1つ存在する必要があります！",
        "invalidSuggestion": "現在のレイアウトと要件では、座席の配置を許可できません。",
        "cannotSendSeatingLockEmailBeforeAllAssigned": "すべての完了した予約に座席が割り当てられるまで、座席割り当てメールを送信できません",
        "failedToSendSeatingLockEmails": "座席割り当てメールの送信に失敗しました",
        "failedToSendSeatingChangedEmail": "座席変更メールの送信に失敗しました",
        "cannotSendSeatingChangedEmailForNonFinishedBooking": "座席変更メールは確定済みの予約に対してのみ送信できます",
        "noEmailAddress": "この予約にはメールアドレスが登録されていません",
        "somethingWentWrong": "問題が発生しました。",
        "transactionFailed": "トランザクションが失敗しました！",
        "cannotBuyAlone": "このチケットタイプは単独で購入することはできません。別のチケットタイプも選択してください。",
        "adultTicketRequired": "子供または乳幼児チケットを予約する場合は、大人チケットが少なくとも1枚必要です。",
        "cannotMixTicketTypes": "このショーでは、1回の予約につき1種類のチケットタイプのみ許可されています。",
        "agentCannotMixTicketTypes": "このアカウントでは、複数のチケットタイプを含む予約を保存できません。同一タイプのアップグレードは引き続き許可されます。",
        "invalidFormat": "無効なフォーマットです",
        "viatorInvalidCredentials": "Viator APIの認証情報が無効です",
        "viatorIntegrationNotFound": "Viator統合が見つかりません",
        "timeslotMustBeSameShow": "新しい時間枠は同じショーに属している必要があります",
        "invalidRentalSlot": "このチケットオプションは選択されたレンタル枠では利用できません",
        "invalidSlotDuration": "枠の長さは正の分数である必要があります",
        "duplicateSlotKey": "各レンタル枠には一意のキーが必要です",
        "ticketTypeMismatch": "座席が割り当てられたチケットタイプと一致しません",
        "twoFactorAlreadyEnabled": "2段階認証はすでに有効になっています",
        "seatNotAvailable": "選択した座席配置ではこの座席は利用できません",
        "verificationFailed": "カートの検証に失敗しました。選択内容を確認して再度お試しください。",
        "verifying": "カートを検証中...",
        "generationServiceUnavailable": "このサーバーではスクリプト生成は利用できません。有効にするには OPENROUTER_API_KEY を設定してください。",
        "generationFailed": "スクリプトを生成できませんでした",
        "fieldRequired": "{{field}}は必須です",
        "customFieldRequired": "「{{field}}」は必須です"
    },
    "labelRowsPerPage": "ページあたりの行数",
    "search": "検索",
    "searchPlaceholder": "検索...",
    "common": {
        "minutesAbbr": "分",
        "actions": "操作",
        "notFound": "ページが見つかりません。",
        "noContent": "利用可能なコンテンツがありません。",
        "backToLogin": "ログインに戻る",
        "backToHome": "ホームに戻る",
        "accessDenied": "アクセスが拒否されました",
        "logout": "ログアウト",
        "cancel": "キャンセル",
        "close": "閉じる",
        "clear": "クリア",
        "clearAll": "すべてクリア",
        "save": "保存",
        "discard": "破棄",
        "showMore": "さらに{{count}}件表示",
        "showLess": "折りたたむ",
        "back": "戻る",
        "next": "次へ",
        "continue": "続行",
        "yes": "はい",
        "no": "いいえ",
        "on": "オン",
        "off": "オフ",
        "none": "なし",
        "add": "追加",
        "edit": "編集",
        "delete": "削除",
        "more": "その他",
        "cardView": "カードビュー",
        "tableView": "テーブルビュー",
        "required": "必須",
        "loading": "読み込み中",
        "all": "すべて",
        "mustBeGreaterThanZero": "0より大きくなければなりません",
        "freesoloAutocompletePlaceholder": "Enterキーで新しい項目を追加",
        "requiredFieldsAreNotFilled": "必須フィールドが入力されていません",
        "translations": "翻訳",
        "language": "言語",
        "set": "設定",
        "languageInfo": "言語を保存するには、ここで設定するだけでは不十分です。外部要素の保存ボタンも押してください。",
        "original": "オリジナル",
        "invalidUrl": "無効なURLです",
        "name": "名前",
        "total": "合計",
        "enabled": "有効",
        "disabled": "無効",
        "changed": "変更",
        "rollback": "ロールバック",
        "cancelReservation": "予約をキャンセル",
        "refundReservation": "払い戻し予約",
        "positiveNumber": "正の数でなければなりません",
        "pay": "支払う",
        "payWith": "以下で支払う",
        "remaining": "残り",
        "willPayInThisTransaction": "この取引で支払います",
        "import": "インポート",
        "resend": "再送信",
        "sending": "送信中...",
        "errorLoadingData": "データの読み込み中にエラーが発生しました",
        "or": "または",
        "url": "URL",
        "text": "テキスト",
        "insert": "挿入",
        "maxPercentage": "100以下である必要があります",
        "remove": "削除",
        "removed": "削除済み",
        "startTypingToSearch": "入力を開始して検索...",
        "noResults": "該当する結果がありません",
        "recentPaymentMethods": "最近",
        "searchOrSelectPaymentMethod": "支払い方法を検索または選択",
        "export": "エクスポート",
        "error_loading_data": "データの読み込み中にエラーが発生しました",
        "translated": "翻訳が成功しました",
        "translationError": "翻訳に失敗しました",
        "translationNotNeeded": "翻訳は不要です - 言語が同じです",
        "autoTranslate": "自動翻訳",
        "expandNotes": "メモを展開",
        "placeholder": "プレースホルダー",
        "manage": "管理",
        "apply": "適用",
        "rebooked": "再予約済み",
        "allTimesIn": "すべての時刻は{{timezone}}です",
        "copiedToClipboard": "クリップボードにコピーしました",
        "create": "作成",
        "error": "エラー",
        "formHasErrors": "保存する前に{{count}}件のエラーを修正してください",
        "invalidEmail": "無効なメールアドレスです",
        "loadError": "データの読み込みに失敗しました",
        "refund": "返金",
        "option": "オプション",
        "previous": "前へ"
    },
    "confirmationModal": {
        "title": "本当に実行しますか？",
        "content": "この操作は元に戻せません。"
    },
    "waitlist": {
        "pageTitle": "ウェイトリスト登録一覧",
        "columns": {
            "subscriberDetails": "登録者情報",
            "timeslot": "日時",
            "requested": "希望内容",
            "fulfillability": "対応可否",
            "activity": "アクティビティ",
            "actions": "操作"
        },
        "labels": {
            "ticketsTotal": "合計 {{count}} 枚",
            "noPhone": "電話番号なし"
        },
        "status": {
            "ready": "案内可能",
            "notEnoughSeats": "空席不足",
            "neverNotified": "未通知"
        },
        "activity": {
            "added": "登録日時: {{-date}}",
            "lastNotified": "最終通知: {{-date}}",
            "sentTimes": "通知回数: {{count}} 回"
        },
        "actions": {
            "reminder": "リマインド送信",
            "sendBulkReminder": "一括リマインド送信",
            "deleteConfirm": "このウェイトリスト登録を削除しますか？",
            "convertToBooking": "予約に変換",
            "convertConfirm": "このウェイトリストのエントリーを予約に変換しますか？座席は自動的に割り当てられ、ゲストに支払いメールが送信されます。"
        },
        "filters": {
            "show": "公演",
            "timeslot": "日時",
            "allTimeslots": "すべての日時",
            "search": "検索",
            "searchPlaceholder": "メールまたは名前で検索...",
            "fulfillableOnly": "案内可能のみ",
            "neverNotifiedOnly": "未通知のみ"
        },
        "empty": "まだウェイトリスト登録はありません。",
        "emptyFiltered": "選択した条件に一致するウェイトリスト登録はありません。",
        "selectShow": "上のフィルターで公演を選択して、ウェイトリスト登録を表示してください。",
        "selectShowAndTimeslot": "上のフィルターで公演と日時を選択して、ウェイトリスト登録を表示してください。",
        "sendingReminders": "リマインドを送信しています...",
        "notify": {
            "reminderSent": "リマインドを送信しました。",
            "notFulfillable": "現在、この登録は案内可能ではありません。",
            "notFound": "登録が見つかりません。",
            "failedReminder": "リマインドの送信に失敗しました。",
            "deleted": "登録を削除しました。",
            "bulkSent": "{{count}} 件のリマインドを送信しました。",
            "bulkSkipped": "スキップ: {{count}}",
            "bulkNotFound": "未検出: {{count}}",
            "bulkFailed": "失敗: {{count}}",
            "convertSuccess": "予約が作成されました。予約ページにリダイレクトしています..."
        }
    },
    "paymentModal": {
        "title": "支払い",
        "content": "先に進むには支払い方法を選択してください。"
    },
    "login": {
        "title": "サインイン",
        "email": "メール",
        "password": "パスワード",
        "login": "サインイン",
        "forgotPassword": "パスワードをお忘れですか？",
        "forgotPasswordTitle": "パスワードをお忘れですか？",
        "forgotPasswordButton": "パスワードリセットメールを送信",
        "passwordModified": "パスワードが正常に変更されました。",
        "passwordRequirements": {
            "length": "パスワードは6文字以上でなければなりません",
            "number": "パスワードには数字を含める必要があります",
            "lowercase": "パスワードには小文字を含める必要があります",
            "uppercase": "パスワードには大文字を含める必要があります",
            "twoPasswordsMatch": "パスワードが一致しません"
        },
        "wrongEmailFormat": "無効なメール形式です",
        "newPasswordTitle": "新しいパスワードを入力",
        "newPassword": "新しいパスワード",
        "confirmPassword": "パスワードを確認",
        "resetPassword": "パスワードをリセット",
        "resetRequest": "リセット要求",
        "forgotPasswordNotifySuccess": "メールアドレスが登録されている場合は、パスワードリセットメールが送信されます。",
        "tiki": {
            "twoFactorTitle": "聖なるコード",
            "twoFactorDescription": "火の精霊が証を求めています。トーテムの6桁のコードを入力してください。",
            "twoFactorLabel": "松明トークン",
            "twoFactorSubmit": "松明に火を灯せ",
            "twoFactorLoading": "炎を読んでいます...",
            "twoFactorError": "精霊がコードを拒否しました。もう一度挑め、戦士よ。"
        }
    },
    "auditlogs": {
        "title": "監査ログ",
        "eventCount": "{{count}}件のイベント",
        "unknownLogType": "不明なログタイプ",
        "columns": {
            "venueName": "会場名",
            "userName": "ユーザー名",
            "logType": "ログタイプ",
            "created": "作成日時",
            "logData": "ログデータ"
        },
        "expandForDetailed": "詳細版を展開",
        "closeForBriefVersion": "簡易版を閉じる"
    },
    "capabilities": {
        "title": "デフォルト権限",
        "sectionTitle": "権限",
        "custom": "カスタム",
        "resetToDefaults": "デフォルトに戻す",
        "templateDescription": "プリセットを選択して権限をすばやく割り当てるか、以下で個別にカスタマイズしてください。",
        "templates": "クイックテンプレート",
        "templatesSubtitle": "テンプレートをクリックして権限を事前入力し、必要に応じてカスタマイズしてください。",
        "templateActive": "アクティブ",
        "roleCapabilities": "{{role}} 権限",
        "panelSubtitle": "このロールのアクセスレベルと権限を設定します。",
        "status": "ステータス",
        "statusCustomized": "カスタマイズ済み",
        "missingDependency": "必要: {{deps}}",
        "groups": {
            "venues": "会場",
            "shows": "ショー",
            "bookings": "予約",
            "operations": "オペレーション",
            "users": "ユーザー",
            "payment_methods": "支払い方法",
            "coupons": "クーポン",
            "integrations": "連携",
            "commission_groups": "コミッショングループ",
            "reports_invoices": "レポート・請求書",
            "invoices": "請求書",
            "logs": "ログ",
            "reports": "レポートアクセス",
            "payments": "支払い",
            "system": "システム"
        },
        "groupsSubtitles": {
            "venues": "一覧と詳細",
            "shows": "イベント管理",
            "bookings": "予約フローの管理",
            "operations": "ケータリングとチェックイン",
            "users": "チーム管理",
            "payment_methods": "カード処理",
            "coupons": "割引コード",
            "integrations": "外部連携",
            "commission_groups": "エージェント料金",
            "reports_invoices": "財務データ",
            "invoices": "請求書管理",
            "logs": "監査とメールログ",
            "reports": "レポートごとのアクセス",
            "payments": "支払いのオーバーライド",
            "system": "グローバル設定"
        },
        "groupPermissionsSubtitle": {
            "bookings": "予約作成、変更、返金へのアクセスを制御します。",
            "venues": "会場設定の表示と管理。",
            "shows": "ショーとイベント管理へのアクセスを制御します。",
            "operations": "ケータリングとチェックインビューへのアクセス。",
            "users": "チームメンバーとロールの管理。",
            "payment_methods": "支払い方法の設定。",
            "coupons": "割引コードの作成と管理。",
            "integrations": "外部連携の設定。",
            "commission_groups": "エージェントコミッション料金の管理。",
            "reports_invoices": "財務レポートと請求書へのアクセス。",
            "invoices": "請求書レポートへのアクセス。",
            "logs": "監査とメールログの表示。",
            "reports": "個別のレポートタイプへのアクセスを制御します。",
            "system": "システムレベルの管理。"
        },
        "userSectionSubtitle": "このユーザーのアクセス権と権限を管理します。",
        "superadminBypass": "スーパー管理者は、権限の設定に関係なくすべての機能にフルアクセスできます。設定は不要です。",
        "permissions": "権限",
        "enabled": "有効",
        "saveChanges": "変更を保存",
        "caps": {
            "venues_view": {
                "label": "会場を表示",
                "description": "会場一覧と詳細を表示"
            },
            "venues_manage": {
                "label": "会場を管理",
                "description": "会場の作成、編集、削除"
            },
            "shows_view": {
                "label": "ショーを表示",
                "description": "ショー一覧と詳細を表示"
            },
            "shows_manage": {
                "label": "ショーを管理",
                "description": "ショーの作成、編集、削除"
            },
            "timeslots_view_hidden": {
                "label": "非表示のタイムスロットを表示",
                "description": "ウィジェット、連携、コミッショングループから非表示にされたタイムスロットの表示と予約。内部エージェントと管理者のみ。"
            },
            "bookings_view": {
                "label": "予約を表示",
                "description": "予約一覧と詳細を表示"
            },
            "bookings_manage": {
                "label": "予約を管理",
                "description": "予約の作成と編集"
            },
            "bookings_refund": {
                "label": "予約を返金",
                "description": "予約返金の処理"
            },
            "bookings_import": {
                "label": "予約をインポート",
                "description": "予約の一括インポート"
            },
            "bookings_scope_all": {
                "label": "すべての予約を表示",
                "description": "他のエージェントの予約を表示（これがないと自分の予約のみ表示）"
            },
            "catering_view": {
                "label": "ケータリングビュー",
                "description": "ケータリングビューにアクセス"
            },
            "checkin_view": {
                "label": "チェックインビュー",
                "description": "チェックインビューにアクセス"
            },
            "checkin_finish": {
                "label": "チェックイン完了",
                "description": "タイムスロットのチェックインを終了・再開する"
            },
            "users_manage": {
                "label": "ユーザーを管理",
                "description": "ユーザーの作成、編集、削除"
            },
            "payment_methods_view": {
                "label": "支払い方法を表示",
                "description": "支払い方法を表示"
            },
            "payment_methods_manage": {
                "label": "支払い方法を管理",
                "description": "支払い方法の作成、編集、削除"
            },
            "coupons_view": {
                "label": "クーポンを表示",
                "description": "クーポン一覧と詳細を表示"
            },
            "coupons_manage": {
                "label": "クーポンを管理",
                "description": "クーポンの作成と削除"
            },
            "integrations_manage": {
                "label": "連携を管理",
                "description": "連携の設定"
            },
            "commission_groups_view": {
                "label": "コミッショングループを表示",
                "description": "コミッショングループを表示"
            },
            "commission_groups_manage": {
                "label": "コミッショングループを管理",
                "description": "コミッショングループの作成、編集、削除"
            },
            "waitlist_manage": {
                "label": "ウェイトリストを管理",
                "description": "ウェイトリストの管理"
            },
            "upgrade_manage": {
                "label": "アップグレード管理",
                "description": "アップグレード経路の管理とオファーの送信"
            },
            "reports_view": {
                "label": "レポートを表示",
                "description": "売上などのレポートにアクセス"
            },
            "invoices_view": {
                "label": "請求書を表示",
                "description": "請求書レポートにアクセス"
            },
            "logs_view": {
                "label": "ログを表示",
                "description": "監査ログとメールログを表示"
            },
            "reports_sales_view": {
                "label": "売上レポートを表示",
                "description": "売上レポートへのアクセス"
            },
            "reports_sales_export": {
                "label": "売上レポートをエクスポート",
                "description": "売上レポートをファイルとしてダウンロード"
            },
            "reports_transactions_view": {
                "label": "取引レポートを表示",
                "description": "取引レポートへのアクセス"
            },
            "reports_transactions_export": {
                "label": "取引レポートをエクスポート",
                "description": "取引レポートをファイルとしてダウンロード"
            },
            "reports_manifest_view": {
                "label": "マニフェストレポートを表示",
                "description": "マニフェストレポートへのアクセス"
            },
            "reports_manifest_export": {
                "label": "マニフェストレポートをエクスポート",
                "description": "マニフェストレポートをファイルとしてダウンロード"
            },
            "reports_commission_view": {
                "label": "コミッションレポートを表示",
                "description": "コミッションレポートへのアクセス"
            },
            "reports_commission_export": {
                "label": "コミッションレポートをエクスポート",
                "description": "コミッションレポートをファイルとしてダウンロード"
            },
            "reports_affiliate_sales_view": {
                "label": "アフィリエイト売上レポートを表示",
                "description": "アフィリエイト売上レポートへのアクセス"
            },
            "reports_affiliate_sales_export": {
                "label": "アフィリエイト売上レポートをエクスポート",
                "description": "アフィリエイト売上レポートをファイルとしてダウンロード"
            },
            "reports_affiliate_invoice_view": {
                "label": "アフィリエイト請求書レポートを表示",
                "description": "アフィリエイト請求書レポートへのアクセス"
            },
            "reports_affiliate_invoice_export": {
                "label": "アフィリエイト請求書レポートをエクスポート",
                "description": "アフィリエイト請求書レポートをファイルとしてダウンロード"
            },
            "reports_payout_view": {
                "label": "精算レポートを表示",
                "description": "精算レポートへのアクセス"
            },
            "reports_payout_export": {
                "label": "精算レポートをエクスポート",
                "description": "精算レポートをファイルとしてダウンロード"
            },
            "reports_booking_fee_view": {
                "label": "予約手数料レポートを表示",
                "description": "予約手数料レポートへのアクセス"
            },
            "reports_booking_fee_export": {
                "label": "予約手数料レポートをエクスポート",
                "description": "予約手数料レポートをファイルとしてダウンロード"
            },
            "reports_affiliate_cancelled_refunded_view": {
                "label": "アフィリエイトキャンセル/返金レポートを表示",
                "description": "キャンセルおよび返金されたアフィリエイト予約レポートへのアクセス"
            },
            "reports_affiliate_cancelled_refunded_export": {
                "label": "アフィリエイトキャンセル/返金レポートをエクスポート",
                "description": "キャンセル/返金レポートをファイルとしてダウンロード"
            },
            "seating_modify": {
                "label": "予約の座席変更",
                "description": "個別の予約に対する座席割り当ての変更"
            },
            "seating_cross_ticket_type": {
                "label": "異なるチケットタイプの座席割り当て",
                "description": "異なるチケットタイプの座席を割り当て（管理者オーバーライド）"
            },
            "seating_assignments": {
                "label": "一括座席割り当て",
                "description": "タイムスロットの一括座席割り当てページにアクセスし、予約間で座席を割り当て・移動する"
            },
            "bookings_simplified_tickets": {
                "label": "簡易予約エディター",
                "description": "座席マップや価格編集なしの簡易チケット表示に固定"
            },
            "bookings_modify_past": {
                "label": "過去イベントの予約を変更",
                "description": "イベント開始時刻を過ぎた後でも予約を編集（再予約、人数変更、チケット変更）できるようにする"
            },
            "bookings_show_stats": {
                "label": "予約の統計を表示",
                "description": "予約の統計情報を表示（例: 注文の合計金額）"
            },
            "bookings_overbook": {
                "label": "オーバーブッキング",
                "description": "予約の作成・変更時に座席数および予約済みキャパシティのチェックを無視する"
            },
            "bookings_cross_selling": {
                "label": "クロスセリングを許可",
                "description": "複数のチケットタイプを含む予約変更の保存を許可します。これがない場合、エージェントは1予約につき1種類のチケットタイプに制限されます。同一タイプ内でのアップグレードは引き続き許可されます。"
            },
            "bookings_custom_rollback_times": {
                "label": "カスタムロールバック時間",
                "description": "予約のカスタムロールバック時間ウィンドウを設定します。予約ごとにデフォルトのキャンセル/ロールバック時間制限を上書きできます。"
            },
            "bookings_always_refund": {
                "label": "返金時にキャンセル期限を上書き",
                "description": "ショーのキャンセル期限を過ぎていても、返金付きでキャンセルできるようにします。予約ごとに担当者が明示的に有効化する必要があります — 自動では適用されません。請求済みの予約は引き続きロックされます。"
            },
            "bookings_re_source": {
                "label": "予約の再ソース",
                "description": "予約を別のエージェントに再ソースし、取引の支払いタイプを同じ手数料のオンハウス支払い方法間で切り替えます。"
            },
            "bookings_cancel": {
                "label": "予約のキャンセル",
                "description": "予約をキャンセルします。この権限がない場合、キャンセルボタンは非表示となり、APIレベルでもブロックされます。外部エージェントはデフォルトでこの権限を持ちません。"
            },
            "bookings_bypass_dynamic_pricing": {
                "label": "動的価格設定をバイパス",
                "description": "動的価格設定の連携が有効な場合でも、元の（タイムスロット／既定の）価格で予約します。デフォルトでは管理者のみ。"
            },
            "payments_split_unlimited": {
                "label": "無制限の分割払い",
                "description": "会場の分割払い上限を無視します。会場設定に関わらず、支払いを任意の回数に分割できます。"
            }
        }
    },
    "venues": {
        "model": "会場",
        "title": "会場一覧",
        "singleTitle": "会場",
        "columns": {
            "name": "名前",
            "site": "サイト",
            "availableLanguages": "利用可能な言語",
            "allowedSplitPaymentAmount": "最大分割回数",
            "slug": "スラッグ",
            "tax": "税 (%)",
            "invoiceRemitToName": "請求書の送金先事業体"
        },
        "allowedSplitPaymentAmountHelp": "注文を分割できる最大支払い回数。0 = 無制限、1 = 分割不可。",
        "invoiceRemitToNameHelp": "アフィリエイトの請求書および明細書に印刷される法的事業体名を上書きします。空欄の場合は会場名が使用されます。",
        "newVenueTitle": "新しい会場",
        "importTitle": "FareHarborからインポート",
        "importH2": "スラッグを指定してインポート",
        "defaultName": "新しい会場",
        "defaultSlug": "newvenue",
        "defaultSite": "新しいサイト",
        "isCurrent": "アクティブ",
        "noVenues": "利用可能な会場がありません。",
        "notifications": {
            "added": "会場が正常に追加されました。",
            "updated": "会場が正常に更新されました。",
            "deleted": "会場が正常に削除されました。",
            "deleteError": "会場を削除できません。",
            "importSuccess": "会場データが正常にインポートされました。"
        }
    },
    "users": {
        "model": "ユーザー",
        "title": "ユーザー一覧",
        "columns": {
            "name": "名前",
            "email": "メール",
            "role": "役割",
            "venueName": "会場"
        },
        "roleLabels": {
            "superadmin": "スーパー管理者",
            "user": "ユーザー",
            "admin": "管理者",
            "manager": "マネージャー",
            "agent": "エージェント",
            "executive": "エグゼクティブ",
            "guest": "ゲスト",
            "external_agent": "外部エージェント",
            "accountant": "会計士",
            "caterer": "ケータリング"
        },
        "venueSelect": "会場",
        "newUserTitle": "新しいユーザー",
        "notifications": {
            "added": "招待メールを送信し、ユーザーを会場に追加しました！",
            "updated": "ユーザーが正常に更新されました。",
            "deleted": "ユーザーが会場から正常に削除されました。",
            "deleteError": "ユーザーを削除できません。",
            "switchVenue": "会場を切り替えました",
            "profileUpdated": "ユーザープロファイルが更新されました",
            "twoFactorReset": "2段階認証が正常にリセットされました",
            "twoFactorDisabled": "2段階認証が正常に無効化されました"
        },
        "switchToVenue": "会場を切り替え",
        "myProfile": "マイプロフィール",
        "tabs": {
            "profileDetails": "プロフィール詳細",
            "capabilitiesPermissions": "権限",
            "securityAccess": "セキュリティとアクセス"
        },
        "switchVenueDescription": "会場名をクリックして別の会場に切り替えできます。",
        "noVenues": "利用可能な会場がありません。",
        "userDetails": "ユーザー詳細",
        "myDetails": "マイ詳細",
        "security": "セキュリティ",
        "enableTwoFactor": "2段階認証を有効にする",
        "enableTwoFactorPlaceholderDescription": "認証アプリ（Google Authenticator、Authyなど）で下のQRコードをスキャンしてください。",
        "enterTwoFactorCode": "アプリに表示される6桁のコードを入力してください：",
        "twoFactorVerification": "2段階認証",
        "enterTwoFactorCodeDescription": "続行するには、認証アプリに表示される6桁のコードを入力してください。",
        "invalidTwoFactorCode": "2要素認証コードが無効です。もう一度お試しください。",
        "twoFactorEnabled": "2段階認証が正常に有効になりました！",
        "disableTwoFactor": "2段階認証を無効にする",
        "disableTwoFactorConfirm": "2段階認証を無効にしてもよろしいですか？アカウントのセキュリティが低下します。",
        "resetTwoFactor": {
            "title": "2段階認証のリセット",
            "subtitle": "ここでユーザーの2段階認証をリセットできます。",
            "forceResetTitle": "2FAリセット",
            "forceResetDescription": "ユーザーが再設定するまで、このユーザーの2FAは無効になります。",
            "button": "2FAリセット"
        },
        "passwordOverride": {
            "title": "パスワード上書き",
            "warning": "この操作はユーザーのログインパスワードを即時に上書きします。",
            "generatedPassword": "生成されたパスワード",
            "setRandomButton": "ランダムパスワードを設定",
            "copyButton": "パスワードをコピー",
            "copyShort": "コピー",
            "subtitle": "このユーザーのログイン認証情報を更新します。",
            "statusActive": "有効",
            "warningTitle": "パスワード上書き警告",
            "forceResetTitle": "パスワード強制リセット",
            "forceResetDescription": "サーバー側で安全なシークレットを使って即時にパスワードをリセットします。",
            "generateNewButton": "新しいパスワードを生成",
            "successInfo": "パスワードが正常に生成されました。今すぐコピーしてください。",
            "lastChangedNone": "最終変更: -",
            "lastChangedBy": "最終変更: {{date}} / {{name}}",
            "lastChangedByForgottenPassword": "最終変更: {{date}} / {{name}}（パスワード再設定フロー）",
            "confirmTitle": "パスワード上書きの確認",
            "confirmRandom": "ランダムパスワードを生成してユーザーに設定してよろしいですか？",
            "notifications": {
                "randomSet": "パスワードを正常にリセットしました。",
                "randomSetCopied": "パスワードをリセットし、クリップボードにコピーしました。",
                "copied": "パスワードをクリップボードにコピーしました。"
            }
        }
    },
    "shows": {
        "model": "ショー",
        "title": "ショー一覧",
        "columns": {
            "title": "タイトル",
            "subtitle": "サブタイトル",
            "description": "説明",
            "cancelWindow": "キャンセル可能時間（時間）",
            "cancelDescription": "キャンセルポリシー",
            "needToKnow": "ご確認ください",
            "location": "場所",
            "countryCode": "国コード",
            "destinationCode": "目的地コード",
            "destinationCodeHelper": "まず国を選択してください",
            "venueName": "会場名",
            "enabledAbandonedCartEmail": "カゴ放棄メールを送信",
            "guestCancellationEnabled": "ゲストによる自己キャンセルを許可",
            "reservationTime": "予約時間（分）",
            "reviewText": "レビューテキスト",
            "reviewLink": "レビューリンク（SMS）",
            "tripadvisorUrl": "Tripadvisor URL",
            "timeslotManagement": "タイムスロット管理",
            "iCalUrl": "iCal URL",
            "autoPublishDaysInAdvance": "自動公開（日前）",
            "rollbackTimeSize": "ロールバック時間（分）",
            "rollbackTimeSizeHelp": "= {{hours}}時間 {{minutes}}分",
            "bookingWindow": "予約ウィンドウ（時間）",
            "bookingWindowHelp": "開演{{hours}}時間前以降は予約できません",
            "marketing": {
                "logo": "ロゴ",
                "primaryImage": "メイン画像",
                "extraImages": "追加画像",
                "subheadline": "サブ見出し",
                "tags": "タグ",
                "duration": "所要時間（時間）",
                "location": "場所",
                "email": "メール",
                "phone": "電話",
                "tracking": {
                    "ga4": "Google Analytics 4 ID",
                    "facebook": "Facebook Pixel ID",
                    "tiktok": "TikTok Pixel ID",
                    "linkedin": "LinkedIn Partner ID",
                    "twitter": "Twitter Pixel ID",
                    "snapchat": "Snapchat Pixel ID",
                    "pinterest": "Pinterest Tag ID"
                }
            },
            "senderEmailPrefix": "送信者メールアドレス",
            "senderEmailPrefixHelper": "ショー関連メールの送信者アドレス。デフォルト: no-reply。",
            "delayedSeatAssignmentEnabled": "座席選択を無効化（ウィジェット＋管理画面の自動割り当て）",
            "allowCrossTicketBuying": "1回の取引で異なるチケットタイプの購入を許可する",
            "absorbProcessingFee": "決済手数料を負担する（主催者負担）",
            "allowSeatingGroupRequest": "ゲストが友人と同席を希望できるようにする",
            "rentalMode": "レンタルモード（カバナ・サンベッドの設定可能な枠でのレンタル）",
            "slotTemplateTitle": "レンタル枠",
            "slotTemplateHint": "レンタル日ごとに提供する枠を定義します。各枠は1つのタイムスロットになり、時間帯が重なる枠は座席が競合します。",
            "slotTemplateRentalOffHint": "レンタル枠を設定するにはレンタルモードを有効にしてください。",
            "slotTemplateAdd": "枠を追加",
            "slotTemplateLabel": "ラベル",
            "slotTemplateStartTime": "開始時刻",
            "slotTemplateDuration": "所要時間（分）",
            "slotTemplateIsFullDay": "終日枠",
            "slotTemplateRemove": "枠を削除",
            "slotTemplateMoveUp": "上へ移動",
            "slotTemplateMoveDown": "下へ移動",
            "slotTemplateDuplicateKey": "枠のラベルは一意である必要があります",
            "requireAdultTicket": "カートには少なくとも1枚の大人チケットが必要（子供/乳児のみでは予約不可）",
            "delayedSeatAssignmentUseSeatIdsInEmails": "メールに座席IDを含める（それ以外はテーブルIDのみ）",
            "isBreakingOutFees": "費用と税金の内訳",
            "priceListingMode": "チケット価格表示",
            "fees": "手数料",
            "feesAttributes": {
                "name": "名前",
                "percentage": "パーセンテージ",
                "usd": "USD金額",
                "isTax": "税金",
                "onlineOnly": "オンライン限定"
            },
            "waitlistNotificationEmailsLabel": "キャンセル待ち通知メールアドレス",
            "waitlistNotificationEmailsHelp": "ここに入力したアドレスには、このショーのキャンセル待ちエントリーが受付可能になった際にメールが送信されます。",
            "waitlistNotificationEmailsInvalid": "有効なメールアドレスを入力してください",
            "checkinNotificationEmailsLabel": "チェックイン通知メールアドレス",
            "checkinNotificationEmailsHelp": "ここに入力したアドレスには、このショーのチェックインに関する通知が送信されます。",
            "checkinNotificationEmailsInvalid": "有効なメールアドレスを入力してください",
            "bookingFeeRebateShare": "予約手数料の会場リベート",
            "bookingFeeRebateShareHelp": "この公演の予約手数料のうち会場へ戻す割合 (例: 30)。空欄でなし。",
            "upgradeNotificationEmailsLabel": "アップグレード通知メール",
            "upgradeNotificationEmailsHelp": "予約がアップグレード対象になったときに通知するメールアドレスをカンマ区切りで入力してください。",
            "upgradeNotificationEmailsInvalid": "アップグレード通知リストに無効なメールアドレスがあります",
            "cancellationReasonsTitle": "事前設定されたキャンセル理由",
            "cancellationReasonTitle": "タイトル",
            "cancellationReasonSubtext": "説明",
            "cancellationReasonColor": "キャンセルされたタイムスロットの色",
            "cancellationReasonColorReset": "デフォルトの色にリセット"
        },
        "timeslotManagementValues": {
            "iCalSync": "iCal同期",
            "manual": "手動管理"
        },
        "feeDisplayModes": {
            "noBreakdown": "内訳なし（最終価格のみ）",
            "simpleBreakdown": "シンプル内訳（税・手数料合計）",
            "detailedBreakdown": "詳細内訳（項目別）"
        },
        "priceListingModes": {
            "gross": "グロス（税・手数料込みの価格）",
            "net": "ネット（税・手数料を除く価格。サイドバーに予約手数料と処理手数料を表示）"
        },
        "cancelableAnyTime": "いつでもキャンセル可能",
        "cancelUnit": "時間",
        "newShowTitle": "新しいショー",
        "defaultTitle": "新しいタイトル",
        "defaultDescription": "新しい説明",
        "notifications": {
            "added": "ショーが正常に追加されました。",
            "updated": "ショーが正常に更新されました。",
            "deleted": "ショーが正常に削除されました。",
            "deleteError": "ショーを削除できません。"
        },
        "validation": {
            "reservationTimeMin": "予約時間は5分以上でなければなりません",
            "rollbackTimeSize": "ロールバック時間は5分以上でなければなりません"
        },
        "marketingTitle": "マーケティング",
        "bookingBehaviorGroup": "予約の挙動",
        "notificationsGroup": "通知",
        "pricingDisplayGroup": "価格表示",
        "contactVenue": "会場に連絡",
        "mainInfoTitle": "メイン情報",
        "detailsTitle": "ショーの詳細",
        "otherInfoTitle": "その他の情報",
        "settingsTitle": "設定",
        "settingsTabs": {
            "general": "一般",
            "bookingRules": "予約ルール",
            "content": "コンテンツとポリシー",
            "notifications": "通知",
            "pricing": "料金"
        },
        "feesTitle": "手数料",
        "trackingTitle": "分析とトラッキング",
        "trackingDescription": "このショーのマーケティングプラットフォームのトラッキングIDを設定します。特定のプラットフォームを使用しない場合は、フィールドを空のままにしてください。",
        "stylingTabTitle": "スタイル",
        "stylingTitle": "ウィジェットのスタイル",
        "stylingDescription": "このショーのウィジェットの色をオーバーライドします。空のままにするとデフォルトが使用されます。値はhexカラーで指定してください (例: #ff0033)。",
        "stylingResetAll": "すべてリセット",
        "stylingInvalidHex": "#ff0033 のような hex カラーを入力してください",
        "stylingFields": {
            "primary": "プライマリーカラー",
            "primary-bg": "プライマリーボタン背景",
            "primary-bg-active": "プライマリーボタン背景 (押下時)",
            "primary-bg-hover-and-focus": "プライマリーボタン背景 (ホバー/フォーカス時)",
            "primary-color": "プライマリーボタン文字色",
            "secondary": "セカンダリーカラー",
            "featured-card-bg": "注目カード背景",
            "featured-card-color": "注目カード文字色",
            "header-color": "見出しの色",
            "default-color": "本文の色",
            "default-bg": "背景色"
        },
        "stylingBasicsTitle": "基本設定",
        "stylingAdvancedTitle": "詳細な色のオーバーライド",
        "stylingFontsTitle": "フォント",
        "stylingFontsDescription": "リストから選択するか、任意のGoogle Fontsファミリー名（例：「Crimson Text」「JetBrains Mono」）を入力してEnterを押してください。ウィジェットは実行時にGoogle Fontsからフォントを読み込みます。Interはローカルにバンドルされています。不明な名前は静かにデフォルトにフォールバックします。",
        "stylingFontHeader": "見出しフォント",
        "stylingFontBody": "本文フォント",
        "stylingNightMode": "ナイトモード",
        "stylingNightModeAuto": "システムに従う",
        "stylingNightModeLight": "常にライト",
        "stylingNightModeDark": "常にダーク",
        "stylingSurpriseMe": "おまかせ",
        "feesInfo": "これらの手数料は、このショーのすべての予約に適用されます。これらは、総予約金額のパーセンテージまたは固定のUSD金額である可能性があります。たとえば、5％のサービス料と2.00ドルの処理料を追加できます。これらの手数料は、チェックアウトプロセス中に別々に表示されます。",
        "feesValidation": "各手数料について、パーセンテージまたはUSD金額のいずれかが提供され、0より大きくなければなりません。",
        "noShows": "ショーが見つかりません",
        "actionGroups": {
            "tickets": "チケット",
            "scheduling": "スケジュールとプロモーション",
            "system": "システム",
            "manage": "管理",
            "commissionGroups": "コミッショングループ"
        },
        "verification": {
            "tabTitle": "検証",
            "title": "カート検証スクリプト",
            "description": "オプションの JavaScript 式で、カートが変更されるたびにサーバー側で評価されます。予約ルール（例：「膝の上の子供は単独で購入できない」）の適用や、合計金額の条件付き調整に使用します。",
            "helpHeader": "スクリプトには、完全なカート、合計、連絡先情報、クーポン、（選択された場合）支払い方法、言語を含む `input` オブジェクトが渡されます。スクリプトは数値（セント単位の差分、+/-）を返すか、カートを拒否するために数値の `code` を持つ Error を投げる必要があります。コードは下のメッセージにマッピングされます。",
            "helpExample": "if (input.cart.find(i => i.ticketOptionName === 'Lap child') && input.cart.length === 1) {\n  const e = new Error(); e.code = 801; throw e;\n}\nreturn 0;",
            "scriptLabel": "検証スクリプト",
            "scriptPlaceholder": "// return 0; // 何もしない",
            "messagesTitle": "コード別のエラーメッセージ",
            "messagesDescription": "スクリプトが数値コードでスローすると、購入者の言語に一致するメッセージが表示されます。サポートする各言語に同じコードを追加してください。英語がフォールバックとして使用されます。",
            "noMessages": "まだエラーメッセージが定義されていません。スクリプトが投げる可能性のある各コードに対して追加してください。",
            "codeLabel": "コード",
            "messageLabel": "メッセージ",
            "addMessage": "エラーコードを追加",
            "promptTitle": "ルールを記述する",
            "promptDescription": "ルールが行うべきことを平易な日本語で記述してください。LLM を使用してスクリプトに変換します。プロンプトはショーと共に保存されるため、後で繰り返し編集できます。",
            "promptLabel": "プロンプト",
            "promptPlaceholder": "例：カートに駐車券が含まれている場合、駐車券を最低 2 枚必要とする。エラーコード 901 を使用する。",
            "generateButton": "プロンプトから生成",
            "regenerateButton": "プロンプトから再生成",
            "generating": "生成中...",
            "generationSuccess": "検証スクリプトを生成しました。既存のスクリプトは置き換えられ、新しいエラーメッセージは既存のものとマージされました。詳細設定セクションを確認してショーを保存してください。",
            "generationBehaviorHint": "生成するとスクリプト全体が置き換わります。新しいエラーメッセージは既存のリストにマージされます（既存のコードは保持されます）。",
            "advancedToggle": "詳細設定（スクリプトとメッセージ）",
            "lockedChip": "手動編集済み",
            "generatedChip": "プロンプトから生成",
            "lockedConfirmTitle": "手動編集を上書きしますか？",
            "lockedConfirmBody": "現在のスクリプトは前回の生成後に手動で編集されています。再生成すると上書きされます。続行しますか？",
            "helpPromptLabel": "スクリプトの生成元プロンプト",
            "helpInputLabel": "スクリプトに渡される `input` の構造（LLM にも提供されます）",
            "translationsTitle": "コード {{code}} の翻訳",
            "translationsHint": "言語ごとのメッセージを編集するか、スパークアイコンをクリックして LLM 経由で英語テキストを翻訳します。",
            "translationsSourceLabel": "英語メッセージ（ソース）",
            "translationsNoLanguages": "この会場は英語のみをサポートしています。翻訳を有効にするには、会場により多くの言語を追加してください。",
            "translateButton": "英語から翻訳",
            "translateMissingSource": "翻訳する前に英語のメッセージを入力してください。",
            "formatScript": "スクリプトをフォーマット",
            "copyScript": "スクリプトをコピー",
            "copyAck": "コピーしました！",
            "testRunTitle": "テスト実行（サンドボックス、ブラウザ内）",
            "testInputLabel": "サンプル入力（JSON）",
            "testResultLabel": "結果",
            "testReset": "サンプルにリセット",
            "testRun": "テストを実行",
            "testIdle": "「テストを実行」をクリックして、サンプル入力に対してスクリプトを評価します。",
            "testEmpty": "スクリプトが空です — まず生成するか記述してください。",
            "testBadInput": "サンプル入力が有効な JSON ではありません",
            "testReturned": "スクリプトの戻り値",
            "testThrown": "スクリプトがスローしました",
            "testThrownCode": "スクリプトがスローしました（コード {{code}}）",
            "testElapsed": "実行時間: {{ms}}ms"
        },
        "addCancellationReason": "理由を追加"
    },
    "ticketoptions": {
        "model": "チケットオプション",
        "title": "チケットオプション一覧",
        "columns": {
            "name": "名前",
            "description": "説明",
            "showTitle": "ショータイトル",
            "ageBand": "年齢層",
            "guestVisible": "ゲストに表示",
            "timeslotPeriod": "レンタル枠"
        },
        "timeslotPeriod": {
            "allPeriods": "全ての枠"
        },
        "ageBand": {
            "notDefined": "未定義",
            "adult": "大人",
            "child": "子供",
            "youth": "青少年",
            "infant": "幼児",
            "senior": "シニア"
        },
        "newTicketOptionName": "新しいチケットオプション",
        "defaultName": "新しい名前",
        "defaultDescription": "新しい説明",
        "reorderMode": "チケットオプションの並び替え",
        "notifications": {
            "added": "チケットオプションが正常に追加されました。",
            "updated": "チケットオプションが正常に更新されました。",
            "deleted": "チケットオプションが正常に削除されました。",
            "deleteError": "チケットオプションを削除できません。",
            "reorderSaved": "チケットオプションの順序を保存しました。",
            "reorderError": "チケットオプションの順序の保存に失敗しました。"
        }
    },
    "tickettypes": {
        "model": "チケットタイプ",
        "title": "チケットタイプ一覧",
        "columns": {
            "name": "名前",
            "description": "説明",
            "showTitle": "ショータイトル",
            "showInList": "一覧に表示",
            "canBuyAlone": "単体購入可",
            "priceMatrix": "価格マトリックス",
            "guestVisible": "ゲスト可視",
            "automaticSeating": "自動座席指定",
            "customFields": "カスタムフィールド",
            "ticketSeats": "席",
            "blockLimit": "ブロック制限",
            "checkinTimeBeforeStart": "開始前チェックイン時間（分）",
            "color": "色"
        },
        "automaticSeating": {
            "manual": "手動座席指定",
            "auto": "推奨座席指定",
            "fullauto": "自動座席指定"
        },
        "customFieldsAttributes": {
            "type": "タイプ",
            "name": "名前",
            "description": "説明",
            "required": "必須",
            "showInCatering": "ケータリングビューに表示"
        },
        "customFieldsTypes": {
            "singleLine": "単一行",
            "multiLine": "複数行",
            "dropdown": "ドロップダウン"
        },
        "addNewNote": "新しいメモを追加",
        "newNoteName": "新しいメモ名",
        "newNoteDescription": "新しいメモ説明",
        "removeNote": "メモを削除",
        "additionalInformation": "追加情報",
        "requiredFieldsEmpty": "未入力の必須項目: {{fields}}",
        "noFreeSeatsAvailable": "利用可能な空席がありません",
        "freeTicketSeatNumber": "利用可能な空席数",
        "newTicketTypeName": "新しいチケットタイプ",
        "defaultName": "新しい名前",
        "defaultDescription": "新しい説明",
        "reorderMode": "チケットタイプの並び替え",
        "notifications": {
            "added": "チケットタイプが正常に追加されました。",
            "updated": "チケットタイプが正常に更新されました。",
            "deleted": "チケットタイプが正常に削除されました。",
            "deleteError": "チケットタイプを削除できません。",
            "reorderSaved": "チケットタイプの順序を保存しました。",
            "reorderError": "チケットタイプの順序の保存に失敗しました。"
        },
        "priceMatrixValueNameLabel": "名前",
        "priceMatrixValuePriceLabel": "価格",
        "noPriceMatrix": "価格マトリックスがありません",
        "noCustomFields": "追加情報がありません",
        "priceMatrixWarning": "価格マトリックスの名前と価格を確認してください。購入時にのみ表示されます。",
        "customFieldsInfo": "カスタムフィールドは購入時に追加情報を収集するために使用します。必須か任意かを設定できます。",
        "wrongPriceCalculation": "価格計算が間違っています！",
        "improvedPriceMatrixInfo": "各チケットオプションの価格を入力してください。利用できない組み合わせには空欄のままにしてください（空欄は組み合わせなしを意味し、0も有効な価格です）。",
        "errorLoadingTicketOptions": "この公演のチケットオプションの読み込み中にエラーが発生しました。",
        "noTicketOptionsAvailable": "この公演にはチケットオプションがありません。まずチケットオプションを追加してください。",
        "ticketOption": "チケットオプション",
        "price": "価格",
        "noPrice": "価格なし",
        "ticketType": "チケット種別",
        "listView": "リスト表示",
        "matrixView": "マトリックス表示",
        "priceMatrixViewInfo": "価格を変更するには編集モードを切り替えてください。空欄は利用できない組み合わせを意味します。",
        "priceMatrixEmptyState": "最初のチケットタイプとチケットオプションを以下に追加してください。",
        "noTicketTypesHint": "以下に最初のチケットタイプを追加してください。",
        "noTicketOptionsHint": "以下に最初のチケットオプションを追加してください。",
        "matrixSaved": "価格マトリックスを正常に保存しました！",
        "errorLoadingData": "データの読み込み中にエラーが発生しました。",
        "noTicketTypes": "この公演にはチケット種別がありません。",
        "noTicketOptions": "この公演にはチケットオプションがありません。",
        "noTimeslots": "この公演には時間枠がありません。",
        "noBlockLimit": "制限なし",
        "blockLimitInfo": "ゲストごとにタイムスロットあたり販売可能なチケットの最大数。制限なしの場合は空のままにします。",
        "checkinTimeBeforeStartInfo": "このチケット種別のゲストが公演開始の何分前にチェックインすべきか。0 は公演開始時刻と同じです。",
        "colorInfo": "このチケットタイプを座席表で表すために使用される色。16進数のカラーコード（例：#FF5733）を使用する必要があります。",
        "seatMapHintClick": "座席をクリックして選択を切り替えます。",
        "seatMapHintShift": "Shiftキーを押しながらドラッグすると、複数の座席を選択できます。"
    },
    "seats": {
        "model": "席",
        "title": "席一覧",
        "importTitle": "座席のインポート",
        "importSuccess": "座席が正常にインポートされました。",
        "cloneTitle": "座席の複製",
        "cloneDescription": "この座席を複製する会場とショーを選択してください。",
        "cloneSuccess": "座席が正常に複製されました。",
        "columns": {
            "id": "ID",
            "name": "名前",
            "x": "X",
            "y": "Y",
            "rotation": "回転",
            "scale": "スケール",
            "bookable": "予約可能",
            "model": "モデル"
        },
        "upload": {
            "uploadTitle": "座席のアップロード",
            "uploadFormats": "サポートフォーマット：XLSX"
        },
        "notifications": {
            "added": "席が正常に追加されました。",
            "updated": "席が正常に更新されました。",
            "deleted": "席が正常に削除されました。",
            "deleteError": "席を削除できません。",
            "createError": "席を作成できません。",
            "updateError": "席を更新できません。",
            "exportSuccess": "席が正常にエクスポートされました。",
            "arrangementAdded": "配置が作成されました",
            "arrangementDeleted": "配置が削除されました",
            "arrangementError": "配置の更新に失敗しました"
        },
        "import": {
            "toAdd": "追加する席",
            "toUpdate": "更新する席",
            "toDelete": "削除する席",
            "errorsFound": "インポートされたデータにエラーが見つかりました。保存する前に修正してください。",
            "status": "ステータス",
            "changes": "変更内容",
            "customModel": "カスタム",
            "noChangesFound": "実行可能な変更は見つかりませんでした。"
        },
        "validation": {
            "xNumber": "Xは数値である必要があります",
            "yNumber": "Yは数値である必要があります",
            "rotationNumber": "回転は数値である必要があります",
            "rotationRange": "回転は-360から360の間である必要があります",
            "invalidModel": "無効なモデル: {{model}}",
            "bookableBoolean": "予約可能かどうかは真偽値である必要があります",
            "idNotFound": "座席にIDがありますが、現在のショーで見つかりませんでした。新しい座席が作成されます。",
            "missingIdForDelete": "削除する座席のIDがありません。"
        },
        "arrangements": "配置",
        "defaultArrangement": "デフォルト",
        "addArrangement": "配置を追加",
        "arrangementName": "配置名",
        "activeArrangement": "アクティブな座席配置",
        "removeFromArrangement": "配置から削除",
        "active": "アクティブ",
        "deleteArrangementConfirm": "この配置を削除してもよろしいですか？この操作は元に戻せません。"
    },
    "timeslots": {
        "model": "タイムスロット",
        "title": "タイムスロット一覧",
        "full": "満席",
        "available": "空席あり (>{{threshold}})",
        "limited": "残りわずか (1-{{threshold}})",
        "soldOut": "満席 (0)",
        "columns": {
            "showTitle": "ショータイトル",
            "startTime": "開始時間",
            "isReviewEmailSuppressed": "レビューメールを抑制",
            "timeslotPeriod": "レンタル枠",
            "timeslotPeriodNone": "なし（標準イベント）",
            "timeslotGroupId": "レンタル日グループID",
            "timeslotGroupIdHint": "同じレンタル日の枠タイムスロットをリンクします。標準タイムスロットの場合は空白のままにしてください。",
            "isHidden": "非表示のタイムスロット",
            "note": "メモ"
        },
        "isHiddenHelp": "ウィジェット、連携、コミッショングループから非表示になります。「非表示のタイムスロットを表示」権限を持つユーザーのみが表示・予約できます。",
        "newTimeslotName": "新しいタイムスロット",
        "bulkAddName": "タイムスロットの一括追加",
        "createRentalDay": "レンタル日を作成",
        "createRentalDayHint": "選択した日付に設定済みのレンタル枠を作成し、重複する枠を競合検出用にグループ化します。",
        "editRentalDay": "レンタル日を編集",
        "editRentalDayHint": "このレンタル日の日付と各枠の時刻を変更します。すべての予約はタイムスロットと一緒に移動します。",
        "bulkRentalDaysName": "レンタル日を一括追加",
        "rentalDate": "レンタル日",
        "changeTimeslot": "タイムスロットを変更",
        "bulkAdd": {
            "title": "繰り返しスケジュール",
            "daysLabel": "曜日",
            "timeLabel": "時刻",
            "startDateLabel": "開始日",
            "endDateLabel": "終了日",
            "endAfterStart": "終了日は開始日以降である必要があります",
            "preview": "{{count}}件の該当日（既存のタイムスロットはスキップされます）",
            "preview_plural": "{{count}}件の該当日（既存のタイムスロットはスキップされます）",
            "progressLabel": "{{completed}} / {{total}} 件を処理済み（{{percent}}%）",
            "days": {
                "0": "日",
                "1": "月",
                "2": "火",
                "3": "水",
                "4": "木",
                "5": "金",
                "6": "土"
            }
        },
        "bulkRentalDays": {
            "preview": "{{count}}件の該当日（既存のレンタル日はスキップされます）",
            "preview_plural": "{{count}}件の該当日（既存のレンタル日はスキップされます）"
        },
        "notifications": {
            "added": "タイムスロットが正常に追加されました。",
            "updated": "タイムスロットが正常に更新されました。",
            "cancelled": "タイムスロットが正常にキャンセルされました。",
            "uncancelled": "タイムスロットのキャンセルが正常に解除されました。",
            "deleted": "タイムスロットが正常に削除されました。",
            "deleteError": "タイムスロットを削除できません。",
            "exportSuccess": "タイムスロットが正常にエクスポートされました。",
            "syncSuccess": "iCalの同期が正常に完了しました。",
            "syncError": "iCalの同期中にエラーが発生しました。",
            "bulkAdded": "{{created}}件のタイムスロットを作成しました。{{skipped}}件はスキップされました（既に存在します）。",
            "rentalDayCreated": "レンタル日が正常に作成されました（すべての設定枠）。",
            "rentalDayUpdated": "レンタル日が正常に更新されました。",
            "bulkRentalDaysAdded": "{{created}}件のレンタル日を作成しました。{{skipped}}件はスキップされました（既に存在します）。"
        },
        "alert": "このショーはiCal同期が有効です。削除した場合、同期で再作成される可能性があります。",
        "syncButton": "iCal同期",
        "syncing": "同期中...",
        "syncResults": {
            "title": "iCal同期結果",
            "created": "作成されたタイムスロット",
            "removed": "削除すべきタイムスロット",
            "noCreated": "新しいタイムスロットは作成されませんでした。",
            "noRemoved": "削除が必要なタイムスロットはありません。",
            "bookingCount": "（{{count}}件の予約）",
            "bookingCount_plural": "（{{count}}件の予約）",
            "warning": "これらのタイムスロットはiCalカレンダーに存在しないため、予約がある場合は手動で削除する必要があります。"
        },
        "inlineEdit": {
            "editCapacity": "キャパシティを編集",
            "editNote": "メモを編集",
            "booked": "予約済み",
            "notePlaceholder": "内部メモを追加...",
            "unsavedTitle": "未保存の変更",
            "unsavedContent": "未保存の変更があります。破棄しますか？",
            "discard": "破棄",
            "keepEditing": "編集を続ける",
            "unlimited": "無制限"
        },
        "priceMatrix": {
            "title": "カスタム価格",
            "info": "このタイムスロットのカスタム価格を設定します。空欄の場合はチケットタイプの既定価格が適用されます。",
            "ticketType": "チケットタイプ",
            "noData": "この公演には利用可能なチケットタイプまたはチケットオプションがありません。",
            "noPrice": "既定"
        },
        "errors": {
            "notICalEnabled": "このショーはiCal同期が有効になっていません。",
            "noICalUrl": "このショーにはiCal URLが設定されていません。",
            "timezoneInfo": "すべての時間はローカルタイムゾーンで表示され、タイムゾーン変換なしでそのまま保存されます。"
        },
        "assignment": {
            "title": "席割り当て",
            "delayedSeatSettingDisabled": "このショーでは座席選択が有効になっています。この画面は引き続き使用できますが、予約時にゲストが座席を選択できる場合があり、管理画面での自動座席割り当ても有効です。",
            "suggest": "席を提案",
            "sendSeatingLockEmail": "席割り当てメールを送信",
            "sendingSeatingEmails": "席割り当てメールを送信中…",
            "missingSeats": "未割り当て席: {{count}}",
            "unassignedGroups": "未割り当てグループ",
            "allAssigned": "このタイムスロットのすべての予約に席が割り当てられました。",
            "clearSeats": "座席をクリア",
            "noBookings": "このタイムスロットの予約が見つかりません。",
            "paxAndMissing": "人数: {{pax}} | 未割り当て: {{missing}}",
            "requiredTicketTypes": "必要: {{types}}",
            "bookingId": "予約 #{{id}}",
            "seatingLockEmailSent": "席割り当てメールを送信しました。",
            "seatingLockEmailSentOn": "席割り当てメール送信日: {{-date}}",
            "resendSeatingLockEmail": "席割り当てメールを再送信",
            "noCompatibleTicketType": "選択した席は、この予約の未割り当てチケットのいずれとも一致しません。",
            "seatUnavailable": "この席は既に別の予約に割り当てられています。",
            "noMissingSeats": "この予約には既にすべての席が割り当てられています。",
            "saved": "席の割り当てを保存しました。",
            "crossTypeMismatchTooltip": "割り当てられた席がチケットタイプと一致しません。",
            "sendSeatingEmail": "座席メールを送信",
            "resendSeatingChangedEmail": "座席変更 — メール再送",
            "resendSeatingEmail": "座席メールを再送",
            "seatingChangedEmailSent": "座席更新メールを送信しました。",
            "arrangementSeatConflict": "この予約には、選択した配置で利用できない座席が割り当てられています。",
            "unassignAll": "すべての割り当てを解除",
            "unassignAllConfirmTitle": "すべての座席割り当てを解除",
            "unassignAllConfirmBody": "この時間枠の座席割り当て {{count}} 件をすべて削除しますか？マニフェスト内のすべての予約に影響します。",
            "unassignAllSuccess": "{{count}} 件の座席割り当てを解除しました。",
            "sortByCreatedAt": "予約日",
            "sortByBookingId": "予約ID",
            "sortByName": "名前",
            "sortAsc": "昇順",
            "sortDesc": "降順",
            "tabUnassigned": "未割り当て",
            "tabAssigned": "割り当て済み",
            "tableUnknown": "テーブルなし",
            "splitBookingTooltip": "この予約は複数のテーブルに分割されています",
            "showNotes": "メモを表示",
            "hideNotes": "メモを非表示"
        },
        "capacityReservations": "予約可能な席",
        "capacityReservationsInfo": "チケットタイプごとに予約可能な席数を設定します。すでに販売済みの席数より少なくすると、予約を手動でキャンセルするか、他の時間帯に振り替える必要がある場合があります。",
        "bookableHeader": "予約可能",
        "totalHeader": "合計",
        "checkinClosedBanner": "このタイムスロットのチェックインは終了しています。リコン サマリーが記録されました。",
        "cancelTimeslotButton": "タイムスロットをキャンセル",
        "uncancelTimeslotButton": "キャンセルを取り消す",
        "cancelledTitle": "このイベントはキャンセルされました",
        "cancelledBanner": "このタイムスロットはキャンセル済みです",
        "cancelModal": {
            "title": "タイムスロットのキャンセル",
            "confirm": "キャンセルを確定する",
            "customReasonLabel": "カスタム理由"
        }
    },
    "checkinview": {
        "reopenButton": "チェックインを再開",
        "finishButton": "チェックインを完了",
        "finishNote": "終了メモ",
        "stats": {
            "checkedIn": "チェックイン済み",
            "notCheckedIn": "ノーショー",
            "sold": "販売済み（合計）",
            "soldDescription": "チェックイン済み + ノーショー",
            "bySource": "予約元別",
            "source": "予約元",
            "sourceDirect": "直接",
            "byCustomerType": "顧客タイプ別",
            "customerType": "顧客タイプ",
            "email": "メール",
            "checkinNote": "チェックインメモ",
            "unpaidBalance": "未払い残高",
            "seated": "着座",
            "unseated": "非着座",
            "note": "メモ",
            "manifest": "マニフェスト",
            "guest": "ゲスト",
            "tickets": "チケット",
            "statusHeader": "状態",
            "revised": "更新版",
            "revisedDescription": "チェックインが再開され、再度終了されました — このサマリーは以前のものを置き換えます。",
            "suppressReviewEmail": "レビューメールの送信を停止しました"
        },
        "notifications": {
            "closed": "チェックインが正常に終了しました。",
            "reopened": "チェックインが正常に再開されました。",
            "noteSaved": "メモが正常に保存されました。"
        },
        "suppressReviewEmail": "レビューメールの送信を停止する",
        "groupByAgeBand": "年齢層でグループ化"
    },
    "bookings": {
        "model": "予約",
        "title": "予約一覧",
        "audit": {
            "rentalDayMoved": "レンタル日を移動しました"
        },
        "summary": {
            "totalBookings": "予約総数",
            "totalRevenue": "総収益",
            "avgRevenue": "平均 / 予約",
            "totalPersons": "総人数"
        },
        "columns": {
            "bookingId": "予約ID",
            "status": "ステータス",
            "venueName": "会場名",
            "showName": "ショー",
            "timeslot": "タイムスロット",
            "firstName": "名前",
            "lastName": "姓",
            "phone": "電話",
            "email": "メール",
            "language": "言語",
            "note": "メモ",
            "checkinNote": "チェックインメモ",
            "agentName": "エージェント名",
            "commission": "手数料",
            "isCheckedIn": "チェックイン済み",
            "confirmationCode": "確認コード",
            "isReviewEmailSuppressed": "レビューメールを抑制",
            "emailNotifications": "メール通知",
            "smsNotifications": "SMS通知",
            "emailNotificationsDisabled": "メール通知無効",
            "smsNotificationsDisabled": "SMS通知無効",
            "guest": "ゲスト",
            "ticketTypes": "チケットタイプ",
            "pax": "人数",
            "source": "ソース",
            "paymentMethod": "支払い方法",
            "createdAt": "作成日時"
        },
        "newBooking": "新しい予約",
        "create": "作成",
        "sourceOnline": "オンライン",
        "sourceAffiliate": "アフィリエイト",
        "sourceCallCenter": "コールセンター",
        "advancedFiltering": "詳細フィルタ",
        "clearAllFilters": "すべてのフィルタをクリア",
        "clearAll": "すべてクリア",
        "status": "ステータス",
        "filterLabels": {
            "id": "ID",
            "confirmationCode": "確認コード",
            "status": "ステータス",
            "search": "検索",
            "show": "公演",
            "timeslot": "時間枠",
            "ticketType": "チケットタイプ",
            "commissionGroup": "コミッショングループ",
            "paymentMethod": "支払方法"
        },
        "notifications": {
            "added": "予約が正常に追加されました。",
            "updated": "予約が正常に更新されました。",
            "deleted": "予約が正常に削除されました。",
            "deleteError": "予約を削除できません。",
            "cancelReservation": "予約が正常にキャンセルされました。",
            "cancelReservationError": "予約をキャンセルできません。",
            "exportSuccess": "予約が正常にエクスポートされました。",
            "chargeSuccess": "予約に正常に料金を請求しました。"
        },
        "errors": {
            "phoneInvalid": "電話番号には数字・空白・- ( ) + のみ使用できます。",
            "phoneNotEmail": "電話番号の欄にメールアドレスは入力できません。"
        },
        "bookingDetails": "予約 #{{bookingId}}",
        "rebookedTo": "{{code}}に再予約済み",
        "rebookedFrom": "{{code}}から再予約済み",
        "rollback": {
            "timeRemaining": "ロールバックまでの残り時間: {{time}}",
            "overdue": "ロールバック期限切れ — 未払いの項目はまもなく解放されます"
        },
        "bookingDetailsNobooking": "この席の予約はありません",
        "limitedModificationWarning": "この予約は外部連携によって作成されました。変更できるのはメモ、座席、基本的な連絡先情報のみです。返金やキャンセルは元の予約プラットフォームで対応してください。",
        "invoicedBookingWarning": "この予約はアフィリエイト請求書に含まれています。チケットの変更はできません。",
        "unpaidOrdersWarning": "支払う必要のある注文があります。",
        "unsavedLeaveTitle": "未保存の変更",
        "unsavedLeaveMessage": "未保存の変更があり、失われます。このページを離れてもよろしいですか？",
        "bookingContacts": "連絡先情報",
        "reSource": {
            "title": "予約の再ソース",
            "button": "予約の再ソース",
            "success": "予約が正常に再ソースされました。",
            "noCommissionGroup": "コミッショングループなし"
        },
        "resendOnContactChange": {
            "title": "メールを再送しますか？",
            "message": "連絡先メールアドレスが変更されました。最後のメール「{{subject}}」を {{email}} に再送しますか？"
        },
        "editContacts": "連絡先を編集",
        "saveContacts": "連絡先を保存",
        "editAdditionalInformation": "追加情報を編集",
        "saveAdditionalInformation": "追加情報を保存",
        "cancelBooking": "予約をキャンセル",
        "cancelBookingFullRefund": "予約を完全返金でキャンセル",
        "cancelBookingWithRefund": "予約を {{refundValue}} 返金でキャンセル",
        "cancelBookingWithNoRefund": "予約を返金なしでキャンセル",
        "overrideCancelPolicyLabel": "キャンセルポリシーを上書きして返金する",
        "overrideCancelPolicyHelp": "この予約は会場のキャンセル期限を過ぎています。ここで返金すると標準ポリシーを上書きし、監査ログに記録されます。",
        "stillBillableLabel": "このキャンセルもアフィリエイトに請求する",
        "stillBillableReasonField": "理由",
        "stillBillableReasonPrompt": "このキャンセルをアフィリエイト請求に残す理由は？（例：24時間ポリシー違反）",
        "stillBillableReasonPlaceholder": "理由（必須、最大200文字）",
        "contactVenue": "会場に連絡",
        "contactVenueTitle": "会場に連絡",
        "contactVenueMessage": "ご予約に関してサポートが必要な場合は、会場に直接お問い合わせください",
        "changeDate": "日時変更",
        "changeDateWarning": "日時を変更すると、現在の座席割り当てがすべてクリアされます。変更後に座席を再割り当てする必要があります。",
        "changePeriodLabel": "レンタル期間",
        "changePeriodTitle": "{{period}}へ変更",
        "changePeriodConfirm": "この予約を{{period}}に変更しますか？これにより{{impact}}。座席は保存時に再割り当てされます。",
        "changePeriodCharge": "{{amount}}を請求します",
        "changePeriodRefund": "{{amount}}を返金します",
        "changePeriodNoCharge": "料金は変わりません",
        "changePeriodNoPrice": "{{types}}には{{period}}の料金が設定されていないため、この予約は変更できません。",
        "capacityWarning": "この予約は利用可能な定員を超えています: {{details}}。保存できません — チケットを減らすか、別の時間帯を選んでください。",
        "capacityWarningOverbook": "この予約は利用可能な定員を超過します: {{details}}。残定員はマイナスになる可能性があり、座席の割り当ては手動で行う必要があります。意図的な場合のみ確定してください。",
        "capacityWarningDetail": "{{ticketType}} (追加 {{adding}}、利用可能 {{available}})",
        "timeslotChanged": "日時変更済み",
        "autoSeatAll": "全座席を自動割り当て",
        "autoSeatOne": "座席を自動割り当て",
        "autoSeatFailed": "座席の自動割り当てに失敗しました。利用可能な座席がありません。",
        "bookingId": "予約ID",
        "email": "メール",
        "phone": "電話",
        "refundBookingWithAmount": "予約の払い戻し金額: {{refundValue}}",
        "refundBookingWithMaxAmount": "この予約の現在の最大払戻額は {{refundValue}} です",
        "checkinStatus": "チェックインステータス",
        "statusValues": {
            "processing": "処理中",
            "finished": "完了",
            "cancelled": "キャンセル済み"
        },
        "searchById": "予約IDで検索",
        "searchByConfirmationCode": "確認コードで検索",
        "importButton": "インポート",
        "import": {
            "title": "FareHarborからの予約のインポート",
            "connectToFareHarbor": "FareHarborに接続",
            "selectShow": "ショーを選択",
            "fareHarborUrl": "FareHarbor URL",
            "email": "メール",
            "password": "パスワード",
            "connect": "接続してデータを取得",
            "mapItems": "FareHarborのアイテムをショーのアイテムにマッピング",
            "fareHarborVendor": "ベンダー",
            "fareHarborProduct": "プロダクト",
            "fareHarborTicket": "チケット",
            "mapTo": "マッピング先",
            "doNotImport": "インポートしない",
            "startImport": "インポート開始",
            "dryRun": "ドライラン（検証のみ、インポートしない）",
            "createMissingTimeslots": "不足しているタイムスロットを作成",
            "progress": "インポートの進捗",
            "progressText": "{{total}}件中{{finished}}件のバウチャーを処理（{{imported}}件正常にインポート）",
            "errorsTitle": "インポート中に{{count}}件のエラーが発生しました",
            "connectionSuccess": "FareHarborに正常に接続しました",
            "importSuccess": "{{count}}件の予約を正常にインポートしました",
            "importCompletedWithErrors": "インポートが完了しました（{{imported}}件インポート、{{errors}}件のエラー）",
            "errors": {
                "fillAllFields": "すべてのフィールドに入力してください",
                "connectionFailed": "FareHarborへの接続に失敗しました",
                "importFailed": "インポートに失敗しました"
            }
        },
        "massAction": {
            "button": "一括キャンセル / 返金",
            "modalTitle": "{{count}}件の一括処理",
            "warning": "注意: 実行前にゲスト名とアクティビティ詳細を確認してください。",
            "selectedCount": "選択中: {{count}}",
            "clearSelection": "選択解除",
            "selectAllMatchingFilters": "現在のフィルターに一致する全予約を選択（全ページ）",
            "selectAllHint": "Info: ヘッダーのチェックボックスは、現在のページだけでなく、全ページの一致する予約を選択します。",
            "selectingAllPages": "全ページの一致する予約を選択しています...",
            "selectAllError": "全件選択に失敗しました。",
            "noOperableBookings": "現在のフィルターではキャンセルまたは返金可能な予約がありません。",
            "noSelection": "予約が選択されていません。",
            "operationType": "操作タイプ",
            "cancelAndRefund": "予約をキャンセル（返金あり）",
            "cancelWithoutRefund": "予約をキャンセル（返金なし）",
            "refundOnly": "返金のみ",
            "operationHintCancelAndRefund": "選択した予約をキャンセルし、選択した返金方法に基づいて返金します。",
            "operationHintCancelWithoutRefund": "選択した予約を返金なしでキャンセルします。",
            "operationHintRefundOnly": "予約は有効のまま、選択した返金方法に基づいて返金のみ実行します。",
            "refundCalculation": "返金計算",
            "refundFull": "全額返金（100%）",
            "refundPercentage": "割合（%）",
            "refundFixed": "固定金額（$）",
            "percentageInputLabel": "返金率（%）",
            "fixedInputLabel": "固定返金額",
            "executeButton": "実行",
            "runningProgress": "処理中...",
            "resultTitle": "結果",
            "progressLabel": "{{completed}} / {{total}} 完了（{{percent}}%）",
            "resultSuccess": "正常に処理されました。",
            "resultFailed": "処理に失敗しました。",
            "statusSuccess": "成功",
            "statusFailed": "失敗",
            "completedSuccess": "一括処理が完了しました（{{count}}件）。",
            "completedWithFailures": "一括処理は完了しましたが {{failureCount}} 件失敗しました。",
            "invalidRefundAmount": "返金額は0より大きい必要があります。",
            "maxRefundableTotal": "最大返金可能額（合計）：",
            "plannedRefundTotal": "予定返金額（合計）：",
            "gridHeaderId": "ID",
            "gridHeaderBooker": "予約者",
            "gridHeaderPlanned": "予定",
            "gridHeaderMax": "最大"
        },
        "addBooking": "予約を追加",
        "cancellationReasonLabel": "キャンセル理由"
    },
    "bookingitems": {
        "model": "予約アイテム（チケット）",
        "title": "予約",
        "paxSummary": "{{count}} PAX: {{breakdown}}",
        "cateringview": "ケータリングビュー",
        "checkinview": "チェックインビュー",
        "booker": "予約者",
        "columns": {
            "quantity": "数量",
            "ticketOptionName": "チケットオプション",
            "ticketTypeName": "チケットタイプ",
            "ticketSeatName": "席",
            "ticketCount": "チケット",
            "price": "価格",
            "note": "メモ",
            "checkinNote": "チェックインメモ",
            "showTitle": "ショータイトル",
            "originalPrice": "元の価格：{{price}}",
            "priceWithTaxAndFees": "税金および手数料込みの価格"
        },
        "notifications": {
            "checkinNote": {
                "updated": "チェックインメモが正常に更新されました。"
            },
            "exportSuccess": "予約アイテムが正常にエクスポートされました。"
        },
        "netPriceDescription": "正味価格は {{price}} で、税金および手数料は含まれていません。",
        "noBookingForThisSeat": "この席の予約はこのフィルター条件では存在しません",
        "modifyTickets": {
            "title": "チケットを変更",
            "description": "変更内容を再確認してください。「はい」をクリックして確定します。",
            "priceChange": "予約価格が {{oldPrice}} から {{newPrice}} に変更されます。新しい注文が作成されます。最終的な価格（税金および手数料込み）は {{newFinalPriceSum}} で、以前は {{oldFinalPriceSum}} でした。",
            "priceChangeNetRate": "予約価格が {{oldFinalPriceSum}} から {{newFinalPriceSum}} に変更されます。新しい注文が作成されます。ネットレート予約では、請求額は定価から手数料を差し引いた金額で、税金および手数料は適用されません。",
            "noChangesTitle": "変更なし",
            "noChangesContent": "予約アイテムに変更がないことを確認してください。",
            "error": "チケット変更中にエラーが発生しました: {{error}}",
            "success": "チケットが正常に変更されました。",
            "sendNotification": "ユーザーに通知を送信する"
        },
        "editSeats": "席を編集",
        "saveSeats": "席を保存",
        "unsavedChanges": "未保存の変更",
        "cancelEdit": "編集をキャンセル",
        "saveBlockedByCapacity": "保存できません — 利用可能な定員を超えています。オーバーブッキング権限が必要です。",
        "warningPendingOrders": "保留中の注文があります",
        "discardPendingTitle": "保留中の変更を破棄して編集する",
        "discardPendingMessage": "この予約には支払い待ちの保留中の変更があります。破棄して予約を再編集できます。",
        "discardPendingWarning": "確保していた席は解放されます。直前の変更内容はエディタに再読み込みされ、保存前に調整できます。",
        "simplified": {
            "addTickets": "チケットを追加",
            "currentTickets": "現在のチケット",
            "noTickets": "チケットはまだありません",
            "autoSeatingOnSave": "保存時に座席が自動的に割り当てられます",
            "seatsAssignedLater": "座席は後で割り当てられます",
            "switchToSimplified": "簡易表示に切り替え",
            "switchToDetailed": "詳細表示に切り替え",
            "addToTable": "テーブルに追加",
            "removeFromTable": "テーブルから削除",
            "dynamicPriceHint": "動的価格。基本料金 {{base}}。"
        },
        "validation": {
            "seatNotCompatible": "座席は選択されたチケットタイプと互換性がありません",
            "invalidCombination": "このチケットオプションは選択されたチケットタイプと一緒に販売できません",
            "priceDifference": "価格が推奨価格と異なります（{{price}}）"
        },
        "seated": "座席あり",
        "unseated": "座席なし"
    },
    "bookingstatus": {
        "processing": "処理中",
        "finished": "完了",
        "cancelled": "キャンセル済み"
    },
    "orderstatus": {
        "pending": "保留中",
        "refunding": "返金中",
        "settled": "完了",
        "rollback": "ロールバック",
        "refunded": "返金済み"
    },
    "orders": {
        "model": "注文",
        "title": "注文一覧",
        "titleWithTickets": "注文とチケット",
        "ticketTotal": "{{total}}件",
        "notPayable": "この注文はもう支払いできません。",
        "columns": {
            "id": "ID",
            "status": "ステータス",
            "amount": "金額",
            "createdAt": "作成日時",
            "rollbackTimeAt": "ロールバック日時"
        },
        "notifications": {
            "added": "注文が正常に追加されました。",
            "updated": "注文が正常に更新されました。",
            "deleted": "注文が正常に削除されました。",
            "deleteError": "注文を削除できません。",
            "rollbacked": "注文が正常にロールバックされました。",
            "rollbackError": "注文をロールバックできません。",
            "moreTimeAdded": "ロールバック時間が正常に追加されました。",
            "moreTimeError": "ロールバック時間を追加できません。",
            "rollbackTimeSet": "ロールバック時間が正常に設定されました。"
        },
        "addMoreTime": "ロールバック時間を追加",
        "customRollbackModal": {
            "title": "カスタムロールバック時間の設定",
            "nowLabel": "現在時刻 (HST)",
            "targetLabel": "目標ロールバック時間",
            "fromNow": "後",
            "ago": "前",
            "afterCurrent": "現在のロールバック後",
            "beforeCurrent": "現在のロールバック前"
        }
    },
    "transactions": {
        "title": "トランザクション",
        "columns": {
            "id": "ID",
            "showName": "ショー名",
            "startTime": "開始時間",
            "booker": "予約者",
            "finished": "完了",
            "amount": "金額",
            "paymentInfo": "支払い情報",
            "createdAt": "作成日時",
            "payment_type": "支払い種別",
            "refund_note": "返金メモ",
            "finishedBy": "完了者",
            "processing_fee": "処理手数料",
            "total": "合計"
        },
        "showOnlyUnfinished": "未完了のみ表示",
        "showOnlyFinished": "完了のみ表示",
        "fee": "手数料",
        "status": {
            "completed": "完了",
            "processing": "処理中"
        },
        "processingFeeDescription": "支払い方法による追加手数料",
        "totalProcessingFees": "処理手数料合計",
        "processingFeeRefund": "処理手数料は全額キャンセルの場合のみ返金されます",
        "noteSaved": "メモが正常に保存されました。",
        "editNote": "メモを編集",
        "editNoteTitle": "取引メモを編集",
        "noteLabel": "メモ",
        "changePaymentType": {
            "title": "支払いタイプの変更",
            "button": "支払いタイプの変更",
            "label": "支払いタイプ",
            "help": "同じ処理手数料の別の現金支払いタイプに切り替えます。",
            "success": "支払いタイプが正常に変更されました。"
        },
        "processingFeeSaved": "処理手数料を保存しました。",
        "editProcessingFee": "処理手数料を編集",
        "editProcessingFeeTitle": "処理手数料の編集",
        "processingFeeLabel": "処理手数料 ($)"
    },
    "manualrefunds": {
        "title": "手動返金",
        "no_transactions": "手動返金が必要な現金取引は見つかりませんでした。",
        "do_refund": "返金を実行",
        "already_refunded": "返金済み",
        "modal_title": "手動返金の確認",
        "transaction_details": "取引詳細",
        "modal_warning": "この操作により、現金取引が手動で返金済みとしてマークされます。確認する前に、システム外で返金が処理されていることを確認してください。",
        "note_label": "返金メモ",
        "note_placeholder": "返金がどのように処理されたかの詳細を入力してください...",
        "confirm_refund": "返金を確認",
        "refund_success": "手動返金が正常に完了としてマークされました。",
        "refund_error": "返金を完了としてマークできませんでした。もう一度お試しください。"
    },
    "emaillogs": {
        "title": "メールログ",
        "model": "メールログ",
        "unknownLogType": "不明なログタイプ",
        "columns": {
            "userName": "ユーザー名",
            "to": "宛先",
            "subject": "件名",
            "result": "結果",
            "content": "内容",
            "created": "作成日時",
            "type": "タイプ"
        },
        "resendEmail": "メールを再送信",
        "emailHasBeenSentAgain": "メールが再送信されました！",
        "areYouSureResend": "本当にこのメールを再送信しますか？",
        "viewEmail": "メールを表示",
        "mail": "メール",
        "modal": {
            "date": "日付",
            "from": "差出人",
            "to": "宛先",
            "subject": "件名",
            "result": "結果",
            "sender": "送信元アドレス"
        },
        "emailTester": "メールテンプレートテスター",
        "emailTesterTemplate": "テンプレート",
        "emailTesterVariant": "バリアント",
        "emailTesterVariantDefault": "デフォルト",
        "emailTesterLanguage": "言語",
        "emailTesterSelectTemplate": "プレビューするテンプレートを選択してください",
        "emailTesterDesktop": "デスクトップ表示",
        "emailTesterMobile": "モバイル表示"
    },
    "paymentmethods": {
        "model": "支払い方法",
        "title": "支払い方法一覧",
        "columns": {
            "id": "ID",
            "venueName": "会場名",
            "slug": "スラッグ",
            "name": "名前",
            "methodType": "方法タイプ",
            "agentOnly": "エージェントのみ",
            "noteRequired": "備考必須",
            "percentage": "パーセンテージ (%)",
            "usd": "固定手数料 (USD)",
            "enabled": "有効"
        },
        "newPaymentMethodTitle": "新しい支払い方法",
        "notifications": {
            "added": "支払い方法が正常に追加されました。",
            "updated": "支払い方法が正常に更新されました。",
            "deleted": "支払い方法が正常に削除されました。",
            "toggled": "支払い方法の有効・無効が正常に切り替えられました。",
            "deleteError": "支払い方法を削除できません。",
            "toggleError": "支払い方法の切り替えに失敗しました。"
        },
        "methodTypes": {
            "card": "カード: カードで支払う",
            "cash": "現金: 現金で支払う",
            "net_rate": "net_rate: ネットレート（ゲストがネット価格を支払う）",
            "net_rate_company": "net_rate_company: ネットレート（法人カードにネット請求）"
        },
        "netRateCompanyInfo": "コミッショングループの登録済み法人カードにネット金額（小売価格からコミッションを差し引いた額）が請求されます。エージェントは顧客から外部で小売全額を受け取ります。",
        "paymentBlock": "支払いブロック"
    },
    "refundChunks": {
        "title": "返金チャンク",
        "columns": {
            "name": "名前",
            "max": "最大額",
            "method": "方法",
            "info": "情報",
            "note": "備考",
            "status": "ステータス",
            "refundStatus": "返金ステータス",
            "statusValues": {
                "pending": "保留中",
                "refunded": "返金済み"
            }
        },
        "refundAmount": "返金額",
        "refundButton": "返金"
    },
    "refundModal": {
        "title": "予約の払い戻し",
        "content": "この予約の払い戻し金額を入力してください。"
    },
    "widgetInformations": {
        "description": "説明",
        "hours": "時間",
        "reviewer": "レビュアー",
        "reviewers": "レビュアー一覧",
        "paymentDeadlineExpires": "支払い期限が切れます",
        "paymentExpiredTitle": "支払い期限切れ",
        "paymentExpired": "支払い期限が切れたため、現在の予約は無効です。再度予約を開始してください。",
        "restartBooking": "予約を再開",
        "pricesFor": "価格",
        "pricesForSelectedDateAndTime": "選択した日時の価格"
    },
    "widgetStepNavigation": {
        "step1next": "予約を開始",
        "step2back": "日時を選び直す",
        "step2next": "席を選択",
        "step3back": "チケットを変更",
        "step3next": "予約情報",
        "step4back": "予約情報を変更",
        "step4next": "チケットを確保",
        "step5back": "予約",
        "step5retry": "予約を再試行"
    },
    "widgetSidebarSteps": {
        "datetime": "日時",
        "tickets": "チケット",
        "seats": "席",
        "bookingInformation": "予約情報"
    },
    "widgetDatePicker": {
        "multipleEventsOnSameDay": "開始時間：",
        "emptyOption": "時間未選択",
        "selectedTimeslot": "開始時間：",
        "nextMonth": "翌月",
        "prevMonth": "前月",
        "selectMonth": "月を選択",
        "prevYear": "前年",
        "nextYear": "翌年",
        "dateAndTime": "日時",
        "selectPeriod": "レンタル枠を選択："
    },
    "widgetLocale": "ja-JP",
    "widgetFooter": {
        "notice": "すべての価格は米ドル表示です。",
        "poweredBy": "提供：",
        "poweredByLink": "https://www.fire-knife.com/"
    },
    "widgetInfo": {
        "selectTickets": "チケットを選択",
        "totalPrice": "合計価格：",
        "selectYourSeats": "席を選択",
        "selectedSeats": "選択中の席：",
        "noSeatingForThisTicket": "このチケットに座席指定はありません",
        "suggestedSeats": "推奨座席",
        "acceptSuggestedSeats": "推奨座席を承認",
        "clearSeats": "座席をクリア",
        "invalidSuggestion": "利用可能な座席が不足しています",
        "suggested": "おすすめ",
        "noSeatingRequired": "座席選択は不要です",
        "seatsAssignedBeforeEvent": "座席はイベント前に割り当てられます",
        "switchTicketType": "切り替え"
    },
    "widgetBookingSummary": {
        "cancellationPolicy": "キャンセルポリシー",
        "needToKnow": "ご確認ください",
        "bookingSummaryTitle": "予約概要",
        "tableColumns": {
            "quantity": "数量",
            "name": "チケット名 (SKU)",
            "pricePerItem": "単価",
            "totalCost": "合計"
        },
        "taxes": "税金",
        "fees": "手数料",
        "fee": "手数料",
        "tax": "税",
        "subtotal": "小計",
        "subtotalNet": "小計 (正味)",
        "totalFees": "手数料合計",
        "totalTaxes": "税金合計",
        "total": "合計",
        "grandTotal": "総合計",
        "bookingTotal": "予約合計",
        "bookingFee": "予約手数料",
        "bookingFeeInfo": "予約手数料の情報",
        "bookingFeeInfoText": "予約手数料には、適用される税金および手数料が含まれています。",
        "ticketTypeLabel": "チケットタイプ",
        "seatLabel": "席",
        "pendingRemoved": "支払いが完了すると、このアイテムは予約から削除されます。",
        "pendingAdd": "支払いが完了すると、このアイテムは確定されます。",
        "otherFees": "その他の手数料"
    },
    "widgetBookingInformation": {
        "contactInformation": "連絡先情報",
        "firstName": "名前",
        "lastName": "姓",
        "name": "名前",
        "email": "メール",
        "phone": "電話",
        "emailError": "メールの形式が無効です。メールアドレスを確認してください。",
        "phoneError": "有効な電話番号を入力してください（数字・空白・-・()・+ のみ使用可能）。",
        "smsNotificationInfo": "設定した場合、予約に関するSMS通知をお送りします。",
        "seatingGroupCheckbox": "友達と一緒に座りたい",
        "seatingGroupDescription": "スタッフはできる限りグループを同じ席に案内します。予約を照合できるよう、メモを残してください — 詳しいほど助かります。",
        "seatingGroupNoteLabel": "誰と一緒に座りますか？",
        "seatingGroupNotePlaceholder": "例：田中太郎、予約コード #1234、または「田中グループ」",
        "seatingGroupNoteRequired": "グループを特定できるようメモを入力してください"
    },
    "widgetWaitlist": {
        "changeTickets": "チケットを変更",
        "unavailableTitle": "現在予約できません",
        "selectedTicketsStatus": "選択したチケット状況",
        "joinTitle": "ウェイトリストに登録",
        "joinDescription": "以下に詳細を入力してください。選択したチケットの座席が利用可能になった場合にご連絡します。",
        "statusAvailable": "利用可能",
        "statusSoldOut": "売り切れ",
        "joinButton": "ウェイトリストに登録",
        "noPaymentRequired": "これはウェイトリスト登録です。\n今すぐの支払いは不要です。",
        "bookingSummaryTitle": "予約概要",
        "waitlistLabel": "ウェイトリスト",
        "waitlistAvailable": "ウェイトリスト受付中",
        "requestSubmitted": "リクエスト送信済み",
        "contactLabel": "連絡先",
        "contactConfirmed": "確認済み",
        "waitlistStatusLabel": "ウェイトリスト状況:",
        "pendingAvailability": "空き待ち",
        "noPaymentProcessed": "ウェイトリスト項目に対する決済は行われていません。",
        "successTitle": "ウェイトリストに登録されました！",
        "successDescriptionRich": "<strong>{{date}}</strong> の <strong>{{tickets}}</strong> のリクエストを受け付けました。座席が利用可能になり次第、<email>{{email}}</email> にお知らせします。",
        "returnHome": "ホームに戻る"
    },
    "upgrades": {
        "pageTitle": "アップグレード",
        "sendingOffers": "オファーを送信中...",
        "selectShowAndTimeslot": "公演と時間枠を選択してアップグレードオファーを表示",
        "empty": "利用可能なアップグレードオファーはありません",
        "emptyFiltered": "現在のフィルタに合致するアップグレードオファーはありません",
        "upgradePaths": "アップグレード経路",
        "fromTicketType": "元のチケットタイプ",
        "toTicketType": "アップグレード先チケットタイプ",
        "addPath": "経路を追加",
        "removePath": "経路を削除",
        "pathAdded": "アップグレード経路を追加しました",
        "pathRemoved": "アップグレード経路を削除しました",
        "notify": {
            "offerSent": "アップグレードオファーを送信しました",
            "reminderSent": "リマインダーを送信しました",
            "dismissed": "オファーを取り下げました",
            "bulkSent": "{{count}} 件のオファーを送信しました",
            "bulkSkipped": "{{count}} 件のオファーをスキップしました",
            "bulkFailed": "{{count}} 件のオファー送信に失敗しました"
        },
        "actions": {
            "sendOffer": "オファーを送信",
            "sendBulkOffer": "一括オファー送信",
            "sendReminder": "リマインダーを送信",
            "dismiss": "取り下げる",
            "dismissBookingConfirm": "この予約をアップグレード対象から除外してよろしいですか？",
            "dismissOfferConfirm": "このアップグレードオファーを取り下げますか？ロールバックが発生します。",
            "applyUpgrade": "アップグレードを適用"
        },
        "errors": {
            "priceUnavailable": "アップグレードを自動適用できませんでした - 対象チケットの価格が利用できません。予約を手動で調整してください。"
        },
        "columns": {
            "guest": "ゲスト",
            "group": "グループ",
            "upgradeTo": "アップグレード先",
            "priceDifference": "差額",
            "status": "ステータス",
            "activity": "アクティビティ",
            "actions": "アクション"
        },
        "status": {
            "eligible": "対象",
            "sent": "送信済み",
            "settled": "確定",
            "expired": "期限切れ",
            "declined": "辞退",
            "neverNotified": "未通知"
        },
        "filters": {
            "show": "公演",
            "timeslot": "時間枠",
            "search": "検索",
            "searchPlaceholder": "名前、メール、予約コードで検索",
            "eligibleOnly": "対象のみ",
            "neverNotifiedOnly": "未通知のみ"
        },
        "activity": {
            "lastNotified": "最終通知日",
            "sentTimes": "{{count}} 回送信"
        },
        "labels": {
            "noPhone": "電話番号なし"
        }
    },
    "widgetReservationInfo": {
        "title": "予約情報",
        "startTime": "開始時間",
        "reservationId": "予約ID",
        "contactInformation": "連絡先情報",
        "contactInformationAndOtherData": "連絡先情報とその他データ",
        "status": "ステータス",
        "payment": "支払い",
        "statusValues": {
            "processing": "処理中",
            "finished": "完了",
            "cancelled": "キャンセル済み",
            "pending": "保留中"
        },
        "orders": {
            "title": "注文",
            "orderId": "ID",
            "amount": "金額",
            "status": "ステータス",
            "createdAt": "作成日時",
            "rollbackTimeAt": "ロールバック日時",
            "statusValues": {
                "pending": "保留中",
                "refunding": "返金中",
                "settled": "完了",
                "rollback": "ロールバック",
                "refunded": "返金済み"
            }
        },
        "transaction": {
            "statusValues": {
                "finished": "完了",
                "inprogress": "進行中",
                "pending": "保留中"
            },
            "amount": "金額",
            "transactionId": "トランザクションID",
            "status": "ステータス",
            "paymentMethod": "支払い方法",
            "date": "日付",
            "discountReversalLabel": "割引の取消"
        },
        "paymentMethods": {
            "title": "支払い方法",
            "amountLabel": "この取引で支払う：",
            "note": "備考"
        },
        "card": {
            "oldCard": "カード番号下4桁 {{cardLast4}}、有効期限 {{expMonth}}/{{expYear}}",
            "newCard": "新しいカードを登録"
        },
        "notes": "メモ",
        "payButton": "支払う",
        "refundChunks": {
            "title": "返金チャンク",
            "name": "名前",
            "max": "最大金額",
            "method": "方法",
            "info": "情報",
            "note": "備考",
            "status": "ステータス",
            "refundStatus": "返金ステータス",
            "statusValues": {
                "pending": "保留中",
                "refunded": "返金済み"
            },
            "refundAmount": "返金額",
            "refundButton": "返金",
            "invalidAmount": "無効な返金額",
            "fullRefundRequired": "利用可能なすべての支払い方法に返金額の全額 ({{amount}}) を配分する必要があります。",
            "couponContactAgent": "このご予約にはクーポンが含まれているため、このページからは返金を処理できません。返金をご希望の場合は会場までお問い合わせください。",
            "contactVenueButton": "会場に連絡する"
        },
        "paymentDetails": {
            "oneTimePayment": "一括払い",
            "splitPayment": "分割払い",
            "single": "単一",
            "split": "分割",
            "payableAmount": "支払うべき金額:",
            "processingFee": "処理手数料",
            "processingFeeDisclaimer": "海外カードや分割払いの場合は、追加の手数料がかかる場合があります。",
            "totalCharge": "合計請求額",
            "processingFeeWillBeIncluded": "Processing fee will be included in the total charge. The processing fee is: {{fee}}",
            "includesProcessingFee": "{{fee}}の処理手数料を含む",
            "wantToSplit": "お支払いを分割しますか？",
            "remainingNotice": "残りの{{amount}}は次の取引でお支払いいただく必要があります。",
            "paymentXofY": "{{current}} / {{max}} 回目の支払い",
            "unlimitedSplitPayments": "無制限の分割払いが許可されています"
        }
    },
    "image": {
        "upload": "画像をアップロード",
        "remove": "画像を削除",
        "uploading": "画像をアップロードしています、お待ちください...",
        "add": "画像を追加",
        "image": "画像",
        "imageUrl": "画像URL",
        "imageUrlPlaceholder": "https://example.com/image.jpg",
        "imageUploadError": "画像のアップロード中にエラーが発生しました",
        "uploadStarted": "画像のアップロードを開始しました",
        "uploadFinished": "画像のアップロードが完了しました",
        "imageViewer": "画像ビューアー",
        "previousImage": "前の画像",
        "nextImage": "次の画像",
        "closeGallery": "ギャラリーを閉じる"
    },
    "richtext": {
        "linkDescription": "リンクのURLと表示したいテキストを入力してください。リンクは新しいタブで開きます。",
        "imageDescription": "画像をアップロードするか、画像のURLを入力してください。画像はコンテンツの全幅で表示されます。",
        "linkTextPlaceholder": "表示するテキスト",
        "displayAsButton": "ボタンとして表示"
    },
    "onboarding": {
        "title": "オンボーディング",
        "description": "ウェブサイトでウィジェットを使用するには、ウェブサイトの </body> 終了タグの前に次のコードスニペットを追加する必要があります。",
        "way1": "次のjavascript関数を呼び出すことで、予約モーダルをトリガーできます（1234はショーIDであることに注意してください）：",
        "way2": "次のHTMLコードスニペットを使用して、ウェブサイトに予約ボタンを埋め込むこともできます（1234はショーIDであることに注意してください）：",
        "way3": "各ショーには一意のウィジェットスラッグがあるため、モーダルまたはボタンに適切な識別子を使用することが非常に重要です。ショーとそのコードは次のとおりです。",
        "showName": "ショー名",
        "showCall": "ショーコール",
        "directSite": "ショーの直接サイトリンク",
        "showId": "ショーID",
        "bookNow": "今すぐ予約"
    },
    "emails": {
        "subjects": {
            "iCalSyncTimeslotsUpdated": "ICal同期 - タイムスロットが更新されました",
            "completeYourReservation": "ご予約を完了してください - お見逃しなく！",
            "showReminderTomorrow": "リマインダー: 明日は{{showTitle}}です！",
            "reviewExperience": "{{showTitle}}のご体験はいかがでしたか？",
            "refundsRequiringAttention": "対応が必要な返金があります",
            "refundProcessed": "返金処理が完了しました",
            "welcomeToFireknife": "Fireknifeへようこそ！ログインして始めましょう",
            "passwordReset": "Fireknife - パスワードリセット",
            "bookingUpdated": "予約が更新されました",
            "bookingCancelled": "予約がキャンセルされました",
            "bookingCancelledFullRefund": "予約がキャンセルされました - 全額返金",
            "paymentRequired": "お支払いが必要です",
            "reservationConfirmed": "ご予約が確定しました",
            "abandonedCart": "ご予約を完了してください - お見逃しなく！",
            "adminRefundNotification": "対応が必要な返金があります",
            "waitlistTicketsAvailable": "{{showTitle}} のチケットが利用可能になりました",
            "affiliateInvoiceDispatch": "アフィリエイト請求書 {{-showDateFrom}} - {{-showDateTo}}",
            "bookingDateChanged": "予約日時が変更されました",
            "upgradeOffer": "ご予約に対するアップグレードのご案内",
            "checkinClosed": "チェックイン終了 - サマリー",
            "waitlistSeatsAvailable": "キャンセル待ちエントリーが受付可能になりました",
            "upgradeEligibleNotify": "アップグレード対象の予約"
        },
        "messages": {
            "passwordResetSent": "パスワードリセットが送信されました！",
            "passwordResetEmailSent": "パスワードリセットメールが送信されました！",
            "inviteFails": "招待メールの送信に失敗しました。メールアドレスを確認して、もう一度お試しください。",
            "passwordResetFails": "パスワードのリセットに失敗しました。後でもう一度お試しください。",
            "cancelFails": "予約のキャンセルメールの送信に失敗しました。",
            "paymentNeededFails": "予約の支払い要求メールの送信に失敗しました。",
            "refundConfirmationFails": "予約の返金確認メールの送信に失敗しました。",
            "waitlistReminderFails": "ウェイトリスト通知メールの送信に失敗しました。"
        }
    },
    "svgeditor": {
        "chair": "椅子",
        "table": "テーブル",
        "table2": "テーブル2",
        "table3": "テーブル3",
        "table4": "テーブル4",
        "table5": "テーブル5",
        "table6": "テーブル6",
        "stage": "ステージ",
        "fitToFloorplan": "フロアプランに合わせる",
        "zoomIn": "ズームイン",
        "zoomOut": "ズームアウト"
    },
    "payment": {
        "paymentStarted": "支払いが開始されました。しばらくしてから取引の状況を確認してください。",
        "paymentXofY": "{{current}} / {{max}} 回目の支払い",
        "unlimitedSplitPayments": "無制限の分割払いが許可されています"
    },
    "formik": {
        "showPassword": "パスワードを表示",
        "hidePassword": "パスワードを非表示"
    },
    "email": {
        "abandoned_cart": {
            "title": "予約をお見逃しなく！",
            "body1": "素晴らしいイベントがあなたを待っています！カートにアイテムを残したまま予約を完了していないことに気付きました。<br/><br/>ご安心ください、カートはまだ保存されていますが、<b>お早めに</b>予約を完了してください。アイテムがなくなる前に！",
            "ticketsTitle": "チケット",
            "buttonLabel": "予約を完了"
        },
        "admin_refund_notify": {
            "title": "キャンセルウィンドウ内でのキャンセル",
            "body1": "キャンセルウィンドウ内でキャンセルされた予約がありました。ゲストから返金のリクエストがあれば、返金してください。",
            "guestHeader": "ゲスト",
            "bookingHeader": "予約",
            "buttonLabel": "予約を表示"
        },
        "booking_update_notify": {
            "title": "予約が更新されました",
            "subtitle": "エージェントからの更新通知",
            "body1": "チームによって予約が更新されました。詳細は以下の通りです：",
            "messageFrom": "{{agentName}}からのメッセージ：",
            "buttonLabel": "予約を管理",
            "summaryTitle": "更新された予約概要",
            "dateChangedTitle": "日時が変更されました",
            "previousDateLabel": "変更前：",
            "newDateLabel": "変更後："
        },
        "cancel_full_refund": {
            "title": "予約がキャンセルされました - 全額返金",
            "subtitle": "{{showName}}の予約がキャンセルされました",
            "body1": "予約が正常にキャンセルされ、全額返金されます。",
            "cancellationReasonLabel": "キャンセル理由：",
            "refundAmountLabel": "返金額：",
            "refundMethodLabel": "返金方法：",
            "refundTimeframeLabel": "返金予定時期：",
            "cancelledStatus": "キャンセル済み",
            "summaryTitle": "キャンセルされた予約概要",
            "contactUsTitle": "お問い合わせ",
            "contactUsBody": "キャンセルや返金についてご質問がある場合は、こちらまでご連絡ください："
        },
        "cancel_inside_window": {
            "title": "予約がキャンセルされました",
            "subtitle": "{{showName}}の予約がキャンセルされました",
            "body1": "キャンセルウィンドウ内で予約がキャンセルされました。",
            "cancellationReasonLabel": "キャンセル理由：",
            "cancellationPolicyLabel": "キャンセルポリシー：",
            "refundAmountLabel": "返金額：",
            "refundMethodLabel": "返金方法：",
            "refundTimeframeLabel": "返金予定時期：",
            "noRefund": "返金：キャンセルタイミングのため返金はありません。",
            "cancelledStatus": "キャンセル済み",
            "summaryTitle": "キャンセルされた予約概要",
            "contactUsTitle": "お問い合わせ",
            "contactUsBody": "キャンセルについてご質問がある場合は、こちらまでご連絡ください："
        },
        "cancel_partial_refund": {
            "title": "予約がキャンセルされました",
            "subtitle": "{{showName}}の予約がキャンセルされました",
            "body1": "予約が部分返金付きでキャンセルされました。",
            "cancellationReasonLabel": "キャンセル理由：",
            "cancellationPolicyLabel": "キャンセルポリシー：",
            "refundAmountLabel": "返金額：",
            "refundMethodLabel": "返金方法：",
            "refundTimeframeLabel": "返金予定時期：",
            "noRefund": "このキャンセルに対する返金はありません。",
            "cancelledStatus": "キャンセル済み",
            "summaryTitle": "キャンセルされた予約概要",
            "contactUsTitle": "お問い合わせ",
            "contactUsBody": "キャンセルについてご質問がある場合は、こちらまでご連絡ください："
        },
        "delete_timeslot": {
            "title": "iCal同期結果",
            "body1": "<b>{{showName}}</b>のiCalカレンダーを同期しました。結果は以下の通りです。",
            "createdTimeslotsTitle": "作成されたタイムスロット",
            "noNewTimeslots": "新しいタイムスロットは作成されませんでした。",
            "removedTimeslotsTitle": "削除すべきタイムスロット",
            "noRemovedTimeslots": "削除が必要なタイムスロットはありません。",
            "bookingCount": "（予約数：{{count}}）",
            "removedTimeslotsInfo": "これらのタイムスロットはiCalカレンダーに存在しないため、システムから削除する必要があります。予約がある場合は自動削除されません。"
        },
        "existinguserinvite": {
            "greeting": "{{name}}様、",
            "body1": "{{venue}}の会場へのログインが促されました。下のボタンをクリックしてプラットフォームに移動してください。",
            "buttonLabel": "こちらをクリックしてログイン"
        },
        "invite": {
            "greeting": "{{name}}様、",
            "body1": "{{venue}}のFireknifeプラットフォームへの招待を受けました。下のボタンをクリックしてパスワードを作成してください。",
            "commissionGroupContext": "コミッショングループ「{{groupName}}」に追加されました。",
            "showContext": "このグループは次の公演に関連しています：{{showTitle}}。",
            "buttonLabel": "こちらをクリックして新しいパスワードを作成"
        },
        "affiliatetools": {
            "title": "アフィリエイト予約リンク",
            "body1": "以下のリンク経由の予約は自動的にあなたの実績として計上されます。独自のUTMパラメータを追加してキャンペーンを追跡することもできます。",
            "codeLabel": "アフィリエイトコード：",
            "linkLabel": "予約リンク："
        },
        "payment_needed": {
            "title": "お支払いが必要です",
            "subtitle": "{{showName}}の予約を完了してください",
            "body1": "予約はもうすぐ完了です！予約を確定するためにお支払いが必要です。",
            "paymentDueByLabel": "支払期限：",
            "buttonLabel": "支払いを完了",
            "summaryTitle": "予約概要"
        },
        "waitlist_reminder": {
            "title": "チケットが利用可能になりました",
            "subtitle": "{{showName}} のご希望チケットを今すぐ予約できます",
            "body1": "{{subscriberName}}様、ご希望のチケット構成が現在利用可能です。下のボタンから予約を続けてください。",
            "buttonLabel": "今すぐ予約",
            "summaryTitle": "ご希望チケット"
        },
        "upgrade_offer": {
            "title": "アップグレード可能",
            "greeting": "{{name}} 様",
            "vipAvailable": "{{date}} のご予約に対して、期間限定のアップグレードをご用意しました。下記の内容をご確認のうえ、ご希望であればアップグレードを確定してください。",
            "currentTicketsTitle": "アップグレード対象のチケット",
            "upgradeTicketsTitle": "アップグレード後のチケット",
            "priceDifference": "差額：",
            "deadline": "有効期限：",
            "payNow": "アップグレードを確定"
        },
        "post_show_review": {
            "title": "{{showName}}にご参加いただきありがとうございました！",
            "buttonLabel": "レビューを投稿"
        },
        "pwreset": {
            "greeting": "{{name}}様、",
            "body1": "パスワードがリセットされました。下のボタンをクリックして新しいパスワードを作成してください。",
            "buttonLabel": "こちらをクリックして新しいパスワードを作成"
        },
        "refund_confirmation": {
            "title": "返金処理完了",
            "subtitle": "返金が処理されました",
            "body1": "予約の返金を受け取りました。支払い方法によっては、返金が口座に反映されるまで時間がかかる場合があります。",
            "totalRefundAmountLabel": "総返金額：",
            "processingFeeReturnedLabel": "返金された決済手数料：",
            "refundBreakdownLabel": "返金内訳：",
            "refundChunkLabel": "返金{{index}}：",
            "amountLabel": "金額：",
            "methodLabel": "方法：",
            "discountReversalLabel": "種別：",
            "discountReversalValue": "割引の取消（金銭の移動はありません）",
            "transactionIdLabel": "取引ID：",
            "timeframeLabel": "処理予定時期：",
            "refundReasonLabel": "返金理由：",
            "refundAmountLabel": "返金額：",
            "refundMethodLabel": "返金方法：",
            "refundProcessedStatus": "返金処理完了",
            "summaryTitle": "返金済み予約概要",
            "contactUsTitle": "お問い合わせ",
            "contactUsBody": "返金についてご質問がある場合は、こちらまでご連絡ください："
        },
        "checkinLabel": "チェックイン：",
        "showStartsLabel": "公演開始：",
        "checkinAndShowStartsLabel": "チェックイン・公演開始：",
        "reservation_created": {
            "title": "ご予約を承りました！",
            "subtitle": "{{venueName}}からのメッセージ",
            "buttonLabel": "予約を管理",
            "cancellationPolicyTitle": "キャンセルポリシー",
            "needToKnowTitle": "ご確認ください",
            "summaryTitle": "予約概要"
        },
        "show_reminder": {
            "title": "お会いできるのを楽しみにしています！",
            "subtitle": "明日 {{venueName}} にて",
            "buttonLabel": "予約を管理",
            "cancellationPolicyTitle": "キャンセルポリシー",
            "needToKnowTitle": "ご確認ください",
            "summaryTitle": "予約概要",
            "checkInTimeLabel": "チェックイン時間",
            "tableAssignmentLabel": "テーブル割り当て"
        },
        "seating_locked": {
            "subject": "{{showTitle}}の座席が変更されました",
            "title": "座席割り当てが更新されました",
            "reminderMessage": "座席割り当てが更新されました。下記の新しいテーブル割り当てとチェックイン時間をご確認ください。",
            "checkInTimeLabel": "チェックイン時間",
            "assignmentLabel": "テーブル割り当て",
            "assignmentLabelTable": "テーブル割り当て",
            "assignmentLabelSeat": "座席割り当て",
            "buttonLabel": "予約を表示",
            "summaryTitle": "予約概要"
        },
        "seating_locked_manifest_copy": {
            "subject": "座席マニフェスト：{{showTitle}}",
            "intro": "座席の割り当てがゲストにメールで送信されました。以下は現在のチェックイン マニフェストです。",
            "manifest": "マニフェスト"
        },
        "parts": {
            "cart": {
                "totalLabel": "合計",
                "subTotalLabel": "小計",
                "taxesLabel": "税金",
                "feesLabel": "手数料",
                "bookingFeeLabel": "予約手数料",
                "processingFeeNote": "カード決済には{{amount}}の手数料がかかります。",
                "processingFeeLabel": "処理手数料",
                "grandTotalLabel": "総合計",
                "discountLabel": "割引",
                "previouslyRefundedLabel": "過去の返金",
                "refundThisTimeLabel": "今回の返金"
            },
            "footer": {
                "copyright": "© {{year}} {{appName}}. All rights reserved."
            },
            "venue": {
                "addressLabel": "住所",
                "phoneLabel": "電話",
                "reachUsAt": "お問い合わせ先：",
                "getDirectionLabel": "道順を取得",
                "viewDirections": "道順を表示してご来場の計画を立てる"
            }
        },
        "affiliate_invoice_dispatch": {
            "remitTo": "送金先",
            "billedTo": "請求先",
            "billingMethod": "請求方法",
            "itemTitle": "項目",
            "bookings": "件の予約",
            "customers": "名のお客様",
            "footer": "この請求メールは Fireknife により自動生成されました。",
            "columns": {
                "invoice": "請求書",
                "dateRange": "日付範囲",
                "created": "作成日",
                "dueDate": "支払期限",
                "total": "合計",
                "id": "ID",
                "contact": "連絡先",
                "agent": "担当",
                "voucher": "バウチャー",
                "customers": "お客様",
                "item": "項目",
                "availability": "利用日時",
                "ticketAmount": "チケット金額",
                "commissionRate": "手数料率",
                "commissionAmount": "手数料金額",
                "amount": "金額",
                "netAmount": "正味金額",
                "amountDue": "請求額"
            }
        },
        "waitlist_seats_available": {
            "title": "キャンセル待ちエントリーが受付可能になりました",
            "intro": "{{timeslotCount}} 件の公演で合計 {{count}} 件のキャンセル待ちを受け付けられます。",
            "andMore": "…他 {{count}} 件",
            "buttonLabel": "キャンセル待ちを開く",
            "ticketsCount": "{{count}} 枚"
        },
        "upgrade_eligible_notify": {
            "title": "アップグレード対象の予約",
            "intro": "{{timeslotCount}}つの時間帯で{{count}}件の予約がアップグレード対象になりました。",
            "eligibleCount": "{{count}}件の対象予約",
            "totalValue": "アップグレード合計金額: {{amount}}",
            "buttonLabel": "アップグレードを確認"
        }
    },
    "coupons": {
        "title": "クーポン",
        "model": "クーポン",
        "columns": {
            "code": "コード",
            "discountType": "割引タイプ",
            "value": "値",
            "expirationDate": "有効期限",
            "status": "ステータス",
            "uses": "使用回数"
        },
        "discountTypes": {
            "percentage": "パーセント",
            "fixed": "固定金額"
        },
        "statuses": {
            "active": "有効",
            "expired": "期限切れ",
            "depleted": "使用済み",
            "inactive": "無効"
        },
        "generate": "クーポン生成",
        "export": "エクスポート",
        "quantity": "数量",
        "maxUses": "最大使用回数",
        "maxUsesHelp": "無制限にする場合は空欄のままにしてください",
        "minOrderAmount": "最低注文金額",
        "minOrderAmountHelp": "最低金額なしの場合は空欄のままにしてください",
        "unlimited": "無制限",
        "useCustomCode": "カスタムコードを使用",
        "customCode": "カスタムコード",
        "customCodeHelp": "希望のクーポンコードを入力してください",
        "autoGenerateInfo": "{{count}}個のユニークなコードが自動的に生成されます",
        "discountSettings": "割引設定",
        "generationSettings": "生成設定",
        "codeSettings": "コード設定",
        "preview": "プレビュー",
        "summary": "概要",
        "summaryCustom": "コード「{{code}}」のクーポン{{count}}枚",
        "summaryAuto": "{{count}}個のユニークなクーポンコード",
        "summaryPercent": "{{value}}%割引",
        "summaryFixed": "${{value}}割引",
        "notSet": "（未設定）",
        "minOrderNote": "最低注文額: ${{amount}}",
        "belowMinimum": "最低額未満",
        "previewOrder": "注文金額",
        "previewFinal": "最終価格",
        "previewBelowMin": "最低注文額以下",
        "previewMinNote": "* 最低注文額: ${{amount}}",
        "enterCode": "クーポンコードを入力",
        "apply": "適用",
        "verify": "確認",
        "applyCoupon": "クーポンコードを適用",
        "discountApplied": "クーポン適用: {{discount}}",
        "remove": "削除",
        "discount": "割引",
        "invalid": "無効なクーポンコード",
        "expired": "このクーポンは期限切れです",
        "depleted": "このクーポンは使用できません",
        "alreadyUsed": "このクーポンは既に使用済みです",
        "minOrderNotMet": "最低注文金額に達していません",
        "applied": "クーポンが適用されました！",
        "emailRequired": "クーポンを適用する前に、有効なメールアドレスを入力してください",
        "cannotDeleteUsed": "使用済みのクーポンは削除できません",
        "deleteUsedConfirmation": "このクーポンは使用済みです。使用履歴を保存するため、削除ではなく無効化されます。続行しますか？",
        "fields": {
            "maxUses": "最大使用回数",
            "expirationDate": "有効期限",
            "isActive": "有効"
        },
        "editModal": {
            "title": "クーポンを編集",
            "maxUsesHelp": "無制限の場合は空欄のままにしてください"
        },
        "notifications": {
            "generated": "{{count}}個のクーポンが正常に生成されました",
            "generateError": "クーポンの生成中にエラーが発生しました",
            "deleted": "クーポンが正常に削除されました",
            "deleteError": "クーポンの削除中にエラーが発生しました",
            "updated": "クーポンが正常に更新されました",
            "updateError": "クーポンの更新中にエラーが発生しました",
            "codeCopied": "コードがクリップボードにコピーされました",
            "copyError": "コードのコピーに失敗しました"
        },
        "validation": {
            "positiveValue": "値は正の数である必要があります",
            "percentageMax": "パーセントは100を超えることはできません",
            "percentageMin": "パーセントは1以上である必要があります",
            "quantityMin": "数量は1以上である必要があります",
            "quantityMax": "数量は1000を超えることはできません",
            "invalidCode": "無効なクーポンコード",
            "inactiveCode": "このクーポンは現在有効ではありません",
            "expiredCode": "このクーポンは有効期限が切れています",
            "depletedCode": "このクーポンは現在利用できません",
            "belowMinimum": "最低注文金額に達していません"
        }
    },
    "integrations": {
        "title": "連携",
        "model": "連携",
        "configuration": "設定",
        "dynamicPricing": {
            "apiKey": "APIキー",
            "enableToGenerate": "有効にして保存すると生成されます",
            "description": "このAPIキーをRising Tideに渡してください。エンドポイントはすでに把握しているので、このキーで今後のタイムスロット、空き状況、現在の価格を取得し、新しい価格をプッシュします。手動で設定したタイムスロット価格は、同じ組み合わせのプッシュされた価格より常に優先されます。"
        },
        "columns": {
            "status": "ステータス",
            "showTitle": "ショータイトル",
            "name": "名前",
            "type": "連携タイプ",
            "settings": "設定",
            "accessKey": "アクセスキー",
            "supplierId": "サプライヤーID",
            "enabled": "有効",
            "affiliateAgent": "アフィリエイトエージェント",
            "commissionGroup": "コミッショングループ",
            "noCommissionGroup": "コミッショングループなし"
        },
        "newIntegrationName": "新しい連携",
        "notifications": {
            "added": "連携が正常に追加されました。",
            "updated": "連携が正常に更新されました。",
            "deleted": "連携が正常に削除されました。",
            "deleteError": "予約があるため、連携を削除できません。"
        },
        "validation": {
            "affiliateAgentRequired": "選択したコミッショングループのアフィリエイトエージェントを選択してください。"
        },
        "description": "あなたの{{type}}アカウントをAPI認証情報を使用して接続します。",
        "activiter": {
            "widgetUrl": "ウィジェットURL",
            "apiUrl": "API URL",
            "apiKey": "APIキー",
            "noApiKey": "連携を有効にしてAPIキーを生成",
            "enableToGenerate": "連携を有効にするとAPIキーが生成されます",
            "description": "APIキーはActiviter APIへのアクセスを提供するJWTトークンです。ショーのVenueに関連付けられ、有効期限はありません。",
            "apiKeyRegenerated": "APIキーが正常に再生成されました。"
        },
        "viatorNetPrices": {
            "title": "Viator ネット価格",
            "info": "Viator予約のネット価格を設定します。これらの価格はViatorの手数料後に受け取る金額を表します。通常の価格マトリックスに価格が設定されているチケットの組み合わせのみ設定できます。",
            "ticketType": "チケットタイプ",
            "originalPrice": "元の価格",
            "notAvailable": "利用不可 - 通常の価格マトリックスに価格が設定されていません",
            "errorLoading": "チケットデータの読み込みエラー",
            "noTicketsAvailable": "このショーにはチケットタイプまたはオプションがありません"
        },
        "viatorProducts": {
            "title": "Viator商品（手動在庫）",
            "info": "Viatorの在庫を手動で作成します。各商品にはViator向けの名称と1つのチケットタイプがあり、各年齢区分をチケットオプションとカスタムネット価格に割り当てます。空欄のままの年齢区分は提供されません。少なくとも1つの商品を設定すると、Viatorに送信される自動生成の商品リストが置き換えられます。",
            "addProduct": "商品を追加",
            "productName": "商品名",
            "ticketType": "チケットタイプ",
            "ageBand": "年齢区分",
            "option": "チケットオプション",
            "price": "ネット価格",
            "code": "商品コード",
            "notOffered": "提供なし",
            "errorLoading": "チケットデータの読み込みエラー",
            "noTickets": "Viator商品を作成する前に、このショーのチケットタイプとオプションを作成してください。",
            "codeGeneratedOnSave": "コードは保存時に生成されます",
            "originalPrice": "元の価格",
            "overridden": "上書き"
        }
    },
    "invoices": {
        "title": "請求書",
        "generateTitle": "請求書を生成",
        "generateButton": "請求書を生成",
        "historyTitle": "請求書履歴",
        "includeDeleted": "削除済み請求書を表示",
        "selectShow": "ショーを選択",
        "selectCommissionGroup": "コミッショングループを選択",
        "selectScopeMessage": "請求書を生成するにはショーとコミッショングループを選択してください。",
        "selectHistoryScopeMessage": "請求書履歴を表示するにはショーとコミッショングループを選択してください。",
        "deleteConfirm": "この請求書を削除してもよろしいですか？",
        "deleteSuccess": "請求書を削除しました。",
        "noInvoices": "選択した条件に一致する請求書はありません。",
        "active": "有効",
        "deleted": "削除済み",
        "status": "ステータス",
        "batch": "バッチ",
        "sentTo": "送信先",
        "createdAt": "作成日時",
        "download": "ダウンロード",
        "showOlderBatches": "古いバッチを表示 ({{count}})",
        "hideOlderBatches": "古いバッチを隠す",
        "charge": "請求",
        "chargeTitle": "請求書を請求",
        "chargeConfirm": "この請求書をエージェンシーの登録済みカードに請求してもよろしいですか？",
        "chargeSuccess": "請求書が正常に請求されました。",
        "invoiceNumber": "請求書番号",
        "day": "日",
        "addInvoice": "請求書を追加",
        "sendEmail": "メールを送信",
        "sendEmailSuccess": "請求書メールが正常に送信されました。",
        "resendEmail": "メールを再送信",
        "emailSent": "送信済み",
        "tabReceivable": "売掛金",
        "tabPayable": "買掛金"
    },
    "reports": {
        "title": "レポート",
        "reportType": "レポートタイプ",
        "salesReport": "売上レポート",
        "filters": {
            "show": "ショー",
            "allShows": "すべてのショー",
            "dateFrom": "開始日",
            "dateTo": "終了日",
            "showDateFrom": "ショー開始日",
            "showDateTo": "ショー終了日",
            "bookingDateFrom": "予約開始日",
            "bookingDateTo": "予約終了日",
            "bookingStatus": "予約ステータス",
            "taxBreakout": "税金内訳",
            "showTicketTypeBreakdown": "チケット種別内訳を表示",
            "showTicketOptionBreakdown": "チケットオプション内訳を表示",
            "breakdownNoAffiliate": "「アフィリエイトなし」の内訳",
            "breakdownNoAffiliateAgents": "グループなしエージェントの内訳",
            "hideNoAffiliate": "「アフィリエイトなし」を非表示",
            "hideNoGroup": "コミッショングループなしのエージェントを非表示",
            "includeAllFields": "すべてのフィールドを含む",
            "integrationSource": "インテグレーションソース",
            "none": "なし",
            "viator": "Viator",
            "venue": "会場",
            "agent": "エージェント",
            "allAgents": "すべてのエージェント",
            "commissionGroup": "コミッショングループ",
            "allCommissionGroups": "すべてのコミッショングループ",
            "day": "日",
            "clearDates": "日付フィルターをすべてクリア",
            "paymentType": "支払いタイプ",
            "source": "ソース",
            "fareharbor": "FareHarbor"
        },
        "columns": {
            "id": "ID",
            "bookingId": "予約ID",
            "createdAt": "作成日時",
            "contact": "連絡先",
            "voucher": "バウチャー",
            "customers": "顧客数",
            "availability": "空き状況",
            "showDate": "ショーの日付",
            "amountDue": "未払い額",
            "netAmount": "純額",
            "taxAmount": "税額",
            "integrationPrice": "インテグレーション価格",
            "processingFee": "処理手数料",
            "absorbedProcessingFee": "負担した決済手数料",
            "source": "ソース",
            "commissionGroup": "コミッショングループ",
            "bookingStatus": "予約ステータス",
            "agent": "担当",
            "unrealisedBalance": "残高",
            "unrealisedBalanceTooltip": "注文合計と決済済み金額の差額。正の値＝未収金。負の値＝返金待ち。",
            "bookingFees": "予約手数料",
            "refundedFees": "返金された手数料",
            "netFees": "純手数料",
            "show": "公演"
        },
        "summary": {
            "bookings": "{{count}}件の予約",
            "customers": "{{count}}人の顧客",
            "total": "合計",
            "groupTotal": "グループ合計",
            "grandTotal": "総合計"
        },
        "tableHeader": "{{showTitle}} - {{ticketTypeName}}",
        "noData": "選択したフィルターに該当するデータはありません。",
        "totalAmount": "合計金額",
        "dateRange": "期間",
        "export": "Excelにエクスポート",
        "exportSuccess": "レポートが正常にエクスポートされました。",
        "loading": "レポートデータを読み込み中...",
        "transactionsReport": "トランザクションレポート",
        "manifestReport": "マニフェストレポート",
        "transactions": {
            "totalRecords": "総レコード数",
            "finished": "完了",
            "pending": "保留中",
            "columns": {
                "bookingId": "予約ID",
                "show": "ショー",
                "orderId": "注文ID",
                "orderAmount": "注文金額",
                "orderStatus": "注文ステータス",
                "transactionId": "トランザクションID",
                "transactionAmount": "トランザクション金額",
                "transactionStatus": "取引ステータス",
                "paymentType": "支払いタイプ",
                "transactionDate": "トランザクション日",
                "source": "ソース"
            }
        },
        "manifest": {
            "columns": {
                "bookingId": "予約ID",
                "show": "ショー",
                "seats": "座席",
                "status": "ステータス",
                "createdAt": "作成日時"
            }
        },
        "commissionReport": "コミッションレポート",
        "commission": {
            "agentName": "エージェント",
            "bookingId": "予約",
            "contact": "連絡先",
            "showTitle": "ショー",
            "availability": "ショーの日付",
            "customers": "顧客数",
            "lineTotal": "注文合計",
            "commissionGroup": "コミッショングループ",
            "commissionAmount": "コミッション"
        },
        "affiliateSalesReport": "アフィリエイト売上レポート",
        "affiliateSales": {
            "affiliateName": "アフィリエイト",
            "ticketType": "チケットタイプ",
            "ticketOption": "チケットオプション",
            "bookingCount": "予約数",
            "pax": "人数",
            "totalSales": "売上合計",
            "percentageOfTotal": "全体の%",
            "noAffiliateSection": "アフィリエイトなし",
            "online": "オンライン",
            "agentsNoGroup": "エージェント（コミッショングループなし）"
        },
        "affiliateAgentReport": "エージェント実績レポート",
        "affiliateAgent": {
            "agentName": "エージェント",
            "commissionGroup": "コミッショングループ",
            "bookingCount": "予約数",
            "totalSales": "売上合計",
            "percentageOfTotal": "全体の%",
            "noGroup": "グループなし"
        },
        "affiliateInvoiceDispatchSuccess": "請求書送信完了: 送信 {{sent}}, スキップ {{skipped}}, 失敗 {{failed}}。",
        "affiliateInvoiceDispatchConfirmTitle": "アクティブな請求書が存在します",
        "affiliateInvoiceDispatchConfirmMessage": "この期間にはすでにアクティブな請求書があります。新しいものを生成して送信しますか？",
        "affiliateInvoiceReport": "アフィリエイト請求レポート",
        "affiliateInvoice": {
            "bookingId": "予約",
            "bookingDate": "予約日",
            "contact": "連絡先",
            "showTitle": "公演",
            "availability": "公演日",
            "customers": "チケット",
            "grossAmount": "総額",
            "commissionAmount": "コミッション",
            "netAmount": "純額"
        },
        "bookingFeeReport": "予約手数料レポート",
        "affiliateCancelledRefundedReport": "アフィリエイトキャンセル/返金レポート",
        "affiliateCancelledRefunded": {
            "bookingId": "予約",
            "status": "ステータス",
            "commissionGroup": "コミッショングループ",
            "agent": "エージェント",
            "ticketType": "チケットタイプ",
            "ticketOption": "チケットオプション",
            "cancellationDate": "キャンセル日",
            "cancellationActor": "キャンセル者",
            "cancellationReason": "理由",
            "originalAmount": "元の金額",
            "refundedAmount": "返金額",
            "processingFees": "処理手数料",
            "grandTotal": "合計"
        },
        "payoutReport": "ペイアウトレポート",
        "payout": {
            "line": "項目",
            "amount": "金額",
            "lines": {
                "totalAmount": "合計金額",
                "processingFees": "決済手数料",
                "bookingFeesTotal": "予約手数料 (合計)",
                "bookingFeesVenueRebate": "予約手数料 - 会場リベート",
                "bookingFeesFireknife": "予約手数料 - Fireknife",
                "netToVenue": "会場への純額"
            },
            "cols": {
                "bookingId": "予約",
                "show": "公演",
                "showDate": "公演日",
                "paymentType": "支払い",
                "source": "ソース",
                "amount": "金額",
                "processingFee": "決済",
                "bookingFee": "予約手数料",
                "venueRebate": "会場リベート",
                "fireknifeFee": "Fireknife 手数料"
            },
            "excludedAffiliateLabel": "{{count}} 件のアフィリエイト予約 ({{amount}}) は除外。"
        }
    },
    "commissionGroups": {
        "manager": "マネージャー",
        "canEditBookings": "メンバーの予約を編集",
        "canEditBookingsHint": "このコミッショングループのエージェントが作成した予約を編集できます（自分の予約だけではありません）。",
        "title": "コミッショングループ",
        "managementTitle": "アフィリエイトの管理",
        "model": "コミッショングループ",
        "columns": {
            "name": "名前",
            "commissionMatrix": "コミッションマトリックス",
            "affiliateContactEmail": "アフィリエイト連絡先メール",
            "billingType": "請求タイプ"
        },
        "assignmentAffiliateCode": {
            "label": "アフィリエイトコード",
            "placeholder": "activityauthority",
            "setCode": "アフィリエイトコードを設定",
            "dialogTitle": "アフィリエイトコード",
            "help": "ウィジェットURLに ?affiliate=<コード> として付与します。このリンク経由の予約は、このショーについてこのユーザーに自動的に紐づきます。紐づけを行わない場合は空欄のままにしてください。",
            "invalid": "英数字、ハイフン、アンダースコアのみ（最大64文字）。",
            "bookingLinkLabel": "予約リンク",
            "directLinkLabel": "直接予約リンク",
            "embedSnippetLabel": "埋め込みスニペット（パートナーサイト用 HTML）",
            "buttonSnippetLabel": "ボタン用スニペット（既存のパートナーボタンに使用）",
            "copy": "コピー",
            "shortDirectLink": "リンク",
            "shortEmbed": "埋め込み",
            "shortButton": "ボタン",
            "unsavedHint": "プレビューのみ — 保存するとスニペットが有効になります。"
        },
        "members": {
            "title": "アフィリエイトとエージェント",
            "description": "招待するとアカウントが作成され、案内メールが送信されます。アフィリエイトコードを作成した場合は予約リンクも含まれます。既存のメンバーを招待すると、その案内メールが再送されます。",
            "affiliateCode": "アフィリエイトコード",
            "showBookingLinks": "予約リンクを表示",
            "resendWelcome": "案内メールを再送",
            "inviteHelp": "案内メールが送信されます。アフィリエイトコードを作成した場合は予約リンクも含まれます。",
            "emptyState": "アフィリエイトはまだいません。招待すると予約リンクがメールで送信されます。",
            "inviteWithCode": "アフィリエイトコードと予約リンクを作成",
            "rowActions": "メンバー操作",
            "copyBookingLink": "予約リンクをコピー",
            "copyEmbedCode": "埋め込みコードをコピー",
            "showSnippets": "予約リンクと埋め込みを表示",
            "hideSnippets": "予約リンクと埋め込みを非表示",
            "copied": "クリップボードにコピーしました",
            "welcomeSentAt": "案内メール送信: {{- date}}",
            "inviteAsManager": "マネージャーとして招待",
            "makeManager": "マネージャーにする",
            "revokeManager": "マネージャー権限を取り消す",
            "allowBookingEdits": "予約の編集を許可",
            "roleUpdated": "メンバーの役割を更新しました",
            "status": {
                "column": "ステータス",
                "pending": "保留中",
                "active": "有効",
                "pendingTooltip": "招待済み - まだパスワードを作成していません"
            }
        },
        "tabs": {
            "settings": "設定",
            "affiliates": "アフィリエイト"
        },
        "partnerCard": {
            "title": "パートナーの登録済みカード",
            "setupLinkHelp": "支払い設定リンク（カードまたは銀行口座を追加するためにパートナーと共有してください）：",
            "setupButton": "Stripe顧客を作成",
            "created": "Stripe顧客が作成されました"
        },
        "checklists": {
            "ar": {
                "title": "ネット請求（A/R）- エージェントが支払いを回収",
                "onHouseOnly": "このグループを「オンハウス」の支払い方法のみに限定してください（エージェントが顧客から現金またはカードで回収します）",
                "markAgentCollected": "下の表でそれらの支払い方法に「エージェント回収」を設定してください",
                "invoice": "請求書にはチケット総額から手数料を差し引いた金額が表示されます（エージェントが会場に支払う額）"
            },
            "ap": {
                "title": "リファラル（A/P）- 会場が支払いを回収",
                "venueCollected": "このグループを会場が回収する支払い方法に限定してください（会場が扱うカードまたは現金）",
                "notAgentCollected": "支払い方法に「エージェント回収」を設定しないでください",
                "invoice": "請求書には手数料の金額が表示されます（会場がエージェントに支払う額）"
            },
            "deposit": {
                "title": "リファラルデポジット - Stripe Connectによる分割",
                "createCardMethod": "Stripe Connectを有効にした新しい「カード」支払い方法を作成してください",
                "limitToThatMethod": "このコミッショングループをその支払い方法のみに限定してください",
                "platformFee": "プラットフォーム手数料は総額から手数料を引いた額に自動設定されます",
                "connectReceives": "Connectアカウントが手数料分を受け取ります"
            },
            "card": {
                "title": "登録済みカード - 自動請求",
                "onHouseOnly": "このグループを「オンハウス」の支払い方法に限定してください（エージェント回収）",
                "setupCustomer": "下でStripe顧客を作成し、支払いリンクをパートナーと共有してください",
                "partnerAddsCard": "パートナーは支払い設定リンクからカードまたは銀行口座を追加します",
                "autoBill": "請求書を作成し、「請求」でパートナーに自動請求してください",
                "pastEventsLocked": "エージェントは過去の公演の予約を変更できないため、請求書の整合性が保たれます"
            },
            "transfer": {
                "title": "ACH／銀行振込 - 登録済みカード v2",
                "sameAsCard": "上記の「登録済みカード」と同じ設定です",
                "partnerAddsBank": "パートナーは支払い設定リンクからカードの代わりに銀行口座（ACH）を追加します",
                "async": "ACH決済は非同期です - ステータス更新はStripeのwebhook経由で届きます"
            }
        },
        "newCommissionGroupTitle": "新規コミッショングループ",
        "matrixType": {
            "percentage": "パーセンテージ (%)",
            "fixed": "固定額 ($)"
        },
        "matrixInfo": "チケットタイプとチケットオプションの各組み合わせのコミッションを設定します。コミッションが発生しない場合は空にしてください。",
        "guestVisibleLockedInfo": "公開中（ゲストに表示される）項目は常に有効で、チェックボックスはロックされています。",
        "sellPermissionsTitle": "販売権限",
        "sellPermissionsInfo": "このコミッショングループが販売できるチケット種別とチケットオプションの組み合わせを選択します。",
        "commissionValuesTitle": "コミッション設定",
        "commissionValuesInfo": "チケット種別とチケットオプションの各組み合わせに対するコミッションを設定します。コミッションなしの場合は空欄のままにしてください。",
        "allOptions": "すべて",
        "noTicketTypesOrOptions": "このショーには利用可能なチケットタイプまたはオプションがありません。",
        "commissionType": "タイプ",
        "commissionValue": "値",
        "assignments": "コミッショングループの割り当て",
        "assignmentsInfo": "このユーザーにショーごとにコミッショングループを割り当てます。ショーごとに割り当てられるコミッショングループは1つだけです。",
        "noAssignment": "なし",
        "notifications": {
            "added": "コミッショングループが正常に追加されました。",
            "updated": "コミッショングループが正常に更新されました。",
            "deleted": "コミッショングループが正常に削除されました。",
            "deleteError": "コミッショングループを削除できませんでした。",
            "assigned": "コミッショングループが正常に割り当てられました。",
            "removed": "コミッショングループの割り当てが正常に削除されました。",
            "assignError": "コミッショングループの割り当て中にエラーが発生しました。",
            "removeError": "コミッショングループの割り当て削除中にエラーが発生しました。",
            "agentInvited": "エージェントが正常に招待されました。",
            "welcomeResent": "案内メールを再送しました。",
            "agentInviteError": "エージェントの招待に失敗しました。メールアドレスを確認してください。",
            "agentRemoved": "エージェントがコミッショングループから削除されました。会場へのアクセス権は残ります - 完全に削除するには管理者にご連絡ください。",
            "agentRemoveError": "エージェントの削除中にエラーが発生しました。"
        },
        "affiliateContactEmailPlaceholder": "billing@example.com, accounting@example.com",
        "affiliateContactEmailHelp": "カンマ区切りで複数のメールアドレスを入力できます。",
        "dynamicPricing": {
            "label": "動的価格設定を有効にする",
            "help": "オンの場合（かつ公演の動的価格設定連携が有効な場合）、このコミッショングループのエージェントは動的価格で予約します。バイパス権限を持つエージェントは常に元の価格で予約します。"
        },
        "billingType": {
            "placeholder": "請求タイプを選択",
            "infoAriaLabel": "請求タイプの説明",
            "options": {
                "ar": "ネット請求 (A/R)",
                "ap": "紹介 (A/P)",
                "deposit": "紹介デポジット",
                "card": "登録済みカード",
                "transfer": "ACH"
            },
            "descriptions": {
                "ar": "アフィリエイト（代理店）がゲストから代金を回収し、月末に会場と請求書を精算します。",
                "ap": "会場が代金を回収し、月末にアフィリエイトにコミッションを支払います。",
                "deposit": "ゲストはクレジットカードで支払いますが、取引は即座に分割されます（Stripe Connect）。ゲストには会場のネット価格用と代理店のコミッション用の2件の別途請求が表示されます。",
                "card": "信頼できるパートナーの場合、システムがカード情報を保存し、発行した請求書に基づいて自動的に請求します。",
                "transfer": "Stripe経由の銀行間送金。クレジットカード取引手数料を節約できます。"
            }
        },
        "management": {
            "members": "メンバー",
            "bookings": "予約",
            "inviteAgent": "エージェントを招待",
            "inviteAgentTitle": "エージェントを招待",
            "inviteAgentName": "エージェントの名前",
            "inviteAgentEmail": "エージェントのメールアドレス",
            "inviteAgentSubmit": "招待",
            "noMembers": "このグループにエージェントはいません。",
            "noBookings": "このグループに予約はありません。",
            "noGroups": "この会場にはコミッショングループが見つかりません。",
            "removeAgent": "エージェントを削除",
            "selectGroup": "コミッショングループ",
            "memberColumns": {
                "name": "名前",
                "email": "メール",
                "role": "役割",
                "manager": "マネージャー",
                "agent": "エージェント"
            },
            "bookingColumns": {
                "agent": "エージェント",
                "booking": "予約番号",
                "contact": "連絡先",
                "availability": "日付",
                "customers": "チケット",
                "lineTotal": "合計",
                "commission": "コミッション",
                "status": "ステータス"
            }
        }
    },
    "crm": {
        "title": "顧客",
        "searchPlaceholder": "名前、メール、電話番号で検索…",
        "viewBooking": "予約を表示",
        "bookings": "予約",
        "bookingsCount": "{{count}} 件の予約",
        "noBookings": "表示できる予約はありません。",
        "unknownName": "不明",
        "columns": {
            "name": "名前",
            "email": "メール",
            "phone": "電話番号",
            "bookingCount": "予約数",
            "lastBooking": "最終予約"
        }
    },
    "admin": {
        "seatingGroup": {
            "connectButton": "グループに接続",
            "modalTitleNew": "座席グループに接続",
            "modalTitleExisting": "座席グループ {{n}}",
            "searchPlaceholderLabel": "接続する予約を検索",
            "searchPlaceholder": "名前、メール、または確認コードで検索",
            "createGroup": "グループを作成",
            "disband": "グループを解散",
            "disbandSuccess": "グループを解散しました",
            "groupCreated": "座席グループが作成されました",
            "membersAdded": "メンバーが追加されました",
            "memberRemoved": "メンバーが削除されました",
            "guestNote": "ゲストのメモ：",
            "badge": "グループ {{n}}",
            "currentMembers": "現在のメンバー",
            "thisBooking": "この予約",
            "removeMember": "グループから削除",
            "wantsToSitWith": "一緒に座りたい",
            "seatGroup": "グループを席に案内",
            "addMembers": "グループに追加",
            "noResults": "このタイムスロットに他の予約が見つかりません",
            "unseatGroup": "グループの席を解除",
            "nameLabel": "グループ名（任意）",
            "namePlaceholder": "例：スミスご一行",
            "saveName": "名前を保存",
            "nameSaved": "グループ名を保存しました"
        }
    }
}
